import React from "react";
import { FaBell, FaReadme, FaUsers } from "react-icons/fa";
import { MdFeedback } from "react-icons/md";
import { HiGlobe } from "react-icons/hi";
import NigerianFlag from "../assets/images/nigeria-flag-icon.png";
import ArgentinaFlag from "../assets/images/argentina-flag-icon.png";
import AustraliaFlag from "../assets/images/australia-flag-icon.png";
import ArubaFlag from "../assets/images/aruba-flag-icon.png";
import BosniaAndHerzegovinaFlag from "../assets/images/bosnia-and-herzegovina-flag-icon.png";
import BangladeshFlag from "../assets/images/bangladesh-flag-icon.png";
import BahrainFlag from "../assets/images/bahrain-flag-icon.png";
import BermudaFlag from "../assets/images/bermuda-flag-icon.png";
import BeninFlag from "../assets/images/benin-flag-icon.png";
import BoliviaFlag from "../assets/images/bolivia-flag-icon.png";
import BrazilFlag from "../assets/images/brazil-flag-icon.png";
import BahamasFlag from "../assets/images/bahamas-flag-icon.png";

// NavLinks
export const navLinks = [
  {
    title: "Dashboard",
    path: "/dashboard",
    icon: (
      <svg
        className="w-4 h-4"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_206_4413"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="32"
          height="32"
        >
          <path d="M0 0H32V32H0V0Z" fill="white" />
        </mask>
        <g mask="url(#mask0_206_4413)">
          <path
            d="M16 19.9902C14.9391 19.9902 13.9217 20.4117 13.1716 21.1618C12.4214 21.912 12 22.9294 12 23.9902V31.9902H20V23.9902C20 22.9294 19.5786 21.912 18.8284 21.1618C18.0783 20.4117 17.0609 19.9902 16 19.9902Z"
            fill="currentColor"
          />
          <path
            d="M22.6667 23.9898V31.9898H28C29.0609 31.9898 30.0783 31.5684 30.8284 30.8182C31.5786 30.0681 32 29.0507 32 27.9898V15.8298C32.0007 15.1367 31.7314 14.4705 31.2493 13.9725L19.9187 1.72313C19.4193 1.18284 18.8136 0.751709 18.1395 0.456846C17.4655 0.161983 16.7377 0.00976562 16.002 0.00976562C15.2663 0.00976562 14.5385 0.161983 13.8645 0.456846C13.1904 0.751709 12.5847 1.18284 12.0853 1.72313L0.774667 13.9685C0.278284 14.4682 -0.00020734 15.1441 1.15822e-07 15.8485V27.9898C1.15822e-07 29.0507 0.421427 30.0681 1.17157 30.8182C1.92172 31.5684 2.93913 31.9898 4 31.9898H9.33333V23.9898C9.35867 20.3538 12.2933 17.3858 15.8373 17.3005C19.5013 17.2111 22.6387 20.2311 22.6667 23.9898Z"
            fill="currentColor"
          />
          <path
            d="M16 19.9902C14.9391 19.9902 13.9217 20.4117 13.1716 21.1618C12.4214 21.912 12 22.9294 12 23.9902V31.9902H20V23.9902C20 22.9294 19.5786 21.912 18.8284 21.1618C18.0783 20.4117 17.0609 19.9902 16 19.9902Z"
            fill="currentColor"
          />
        </g>
      </svg>
    ),
  },
  {
    title: "Access",
    icon: (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.75094 6.18379e-05H7.67075C6.97796 4.02755e-05 6.40023 2.21988e-05 5.94161 0.0616821C5.45752 0.126765 5.02047 0.269933 4.66927 0.621139C4.31806 0.972344 4.1749 1.40939 4.10981 1.89348C4.04815 2.3521 4.04817 2.92981 4.04819 3.6226V3.68254C2.48969 3.73353 1.55382 3.91565 0.903381 4.56609C0 5.46947 0 6.92344 0 9.83139C0 12.7393 0 14.1933 0.903381 15.0967C1.80676 16.0001 3.26073 16.0001 6.16867 16.0001H9.25301C12.161 16.0001 13.6149 16.0001 14.5183 15.0967C15.4217 14.1933 15.4217 12.7393 15.4217 9.83139C15.4217 6.92344 15.4217 5.46947 14.5183 4.56609C13.8679 3.91565 12.932 3.73353 11.3735 3.68254V3.62262C11.3735 2.92983 11.3735 2.3521 11.3119 1.89348C11.2468 1.40939 11.1036 0.972344 10.7524 0.621139C10.4012 0.269933 9.96416 0.126765 9.48008 0.0616821C9.02146 2.21988e-05 8.44373 4.02755e-05 7.75094 6.18379e-05ZM10.2169 3.66417V3.66271C10.2169 2.91938 10.2156 2.42006 10.1656 2.04759C10.1177 1.69177 10.035 1.53948 9.93456 1.439C9.83408 1.33851 9.68179 1.25583 9.32596 1.20799C8.9535 1.15792 8.45418 1.15669 7.71084 1.15669C6.96751 1.15669 6.46819 1.15792 6.09572 1.20799C5.7399 1.25583 5.58761 1.33851 5.48713 1.439C5.38664 1.53948 5.30396 1.69177 5.25612 2.04759C5.20605 2.42006 5.20482 2.91938 5.20482 3.66271V3.66417C5.50711 3.66271 5.82791 3.66271 6.16867 3.66271H9.25301C9.59378 3.66271 9.91458 3.66271 10.2169 3.66417ZM11.5663 5.97596C11.5663 6.40182 11.221 6.74705 10.7952 6.74705C10.3693 6.74705 10.0241 6.40182 10.0241 5.97596C10.0241 5.55011 10.3693 5.20488 10.7952 5.20488C11.221 5.20488 11.5663 5.55011 11.5663 5.97596ZM4.6265 6.74705C5.05236 6.74705 5.39759 6.40182 5.39759 5.97596C5.39759 5.55011 5.05236 5.20488 4.6265 5.20488C4.20065 5.20488 3.85542 5.55011 3.85542 5.97596C3.85542 6.40182 4.20065 6.74705 4.6265 6.74705Z"
          fill="currentColor"
        />
      </svg>
    ),
    items: [
      // { title: "Previleges", path: "/access/privileges" },
      { title: "Roles", path: "/access/roles" },
      { title: "Sub-Admin", path: "/access/sub-admin" },
    ],
  },
  {
    title: "Notification",
    path: "/notification",
    icon: <FaBell />,
  },
  {
    title: "Users Management",
    path: "/users-management",
    icon: (
      <svg
        className="w-4 h-4"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="5.84074" cy="3.36808" r="3.36808" fill="currentColor" />
        <ellipse
          cx="5.89415"
          cy="12.6319"
          rx="5.89415"
          ry="3.36808"
          fill="currentColor"
        />
        <path
          d="M15.7029 12.0853C15.7029 13.4804 13.9889 14.6113 11.8962 14.6113C12.5128 13.9374 12.9367 13.0915 12.9367 12.0864C12.9367 11.0802 12.5118 10.2335 11.8941 9.55924C13.9868 9.55924 15.7029 10.6902 15.7029 12.0853Z"
          fill="currentColor"
        />
        <path
          d="M13.1768 2.82327C13.1768 4.21838 12.0459 5.34934 10.6508 5.34934C10.3465 5.34934 10.0549 5.29556 9.78479 5.197C10.1831 4.49636 10.4106 3.68591 10.4106 2.82233C10.4106 1.95939 10.1835 1.14951 9.78567 0.449224C10.0555 0.350866 10.3469 0.297211 10.6508 0.297211C12.0459 0.297211 13.1768 1.42817 13.1768 2.82327Z"
          fill="currentColor"
        />
      </svg>
    ),
  },
  {
    title: "Promotion Management",
    icon: (
      <svg
        className="w-4 h-4"
        width="17"
        height="20"
        viewBox="0 0 17 20"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.711987 3.51721C1.01065 1.56379 2.61577 0 4.65209 0C5.87113 0 6.9486 0.570733 7.6704 1.44368C7.90532 1.72779 7.85822 2.14276 7.56521 2.37054C7.2722 2.59831 6.84423 2.55265 6.60931 2.26854C6.11782 1.67412 5.41599 1.31868 4.65209 1.31868C3.45004 1.31868 2.36729 2.22488 2.09029 3.52175C2.22449 3.53827 2.35493 3.59368 2.46244 3.68882C2.73983 3.9343 2.75946 4.35134 2.50629 4.6203L1.84427 5.32359C1.71543 5.46047 1.53314 5.53845 1.34202 5.53845C1.1509 5.53845 0.968604 5.46047 0.839764 5.32359L0.177749 4.6203C-0.0754235 4.35134 -0.0557936 3.9343 0.221594 3.68882C0.360549 3.56585 0.537826 3.50926 0.711987 3.51721ZM8.17799 2.81318C8.36911 2.81318 8.5514 2.89117 8.68024 3.02804L9.34226 3.73133C9.59543 4.00029 9.5758 4.41733 9.29841 4.66281C9.15946 4.78578 8.98218 4.84238 8.80802 4.83443C8.50936 6.78784 6.90423 8.35163 4.86792 8.35163C3.73411 8.35163 2.72135 7.85743 2.00484 7.08516C1.75367 6.81444 1.77639 6.39755 2.05559 6.15401C2.33479 5.91047 2.76475 5.9325 3.01592 6.20322C3.5 6.72498 4.1563 7.03295 4.86792 7.03295C6.06996 7.03295 7.15271 6.12676 7.42972 4.82989C7.29552 4.81336 7.16507 4.75795 7.05756 4.66281C6.78018 4.41733 6.76054 4.00029 7.01372 3.73133L7.67573 3.02804C7.80457 2.89117 7.98687 2.81318 8.17799 2.81318Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17 9.45057V12.967C17 16.2824 17 17.9401 15.9378 18.97C14.8755 20 13.1659 20 9.74667 20C6.32741 20 4.61779 20 3.55556 18.97C2.49334 17.9401 2.49334 16.2824 2.49334 12.967V11.4608C2.49334 11.2273 2.49334 11.1106 2.51607 11.014C2.59357 10.6848 2.85871 10.4277 3.19825 10.3525C3.29785 10.3305 3.41839 10.3305 3.65947 10.3305C5.10323 10.3305 5.82511 10.3305 6.42161 10.1988C8.46068 9.74837 10.053 8.20447 10.5175 6.22736C10.6533 5.64898 10.6533 4.94985 10.6533 3.55157C10.6533 3.31962 10.6533 3.20364 10.6766 3.10605C10.7551 2.77611 11.0322 2.51283 11.374 2.44337C11.4751 2.42282 11.5909 2.4251 11.8226 2.42965C13.9085 2.47065 15.1166 2.65133 15.9378 3.44757C17 4.47752 17 6.13521 17 9.45057ZM7.02667 16.7033C6.65111 16.7033 6.34667 16.9985 6.34667 17.3626C6.34667 17.7267 6.65111 18.0219 7.02667 18.0219H12.4667C12.8422 18.0219 13.1467 17.7267 13.1467 17.3626C13.1467 16.9985 12.8422 16.7033 12.4667 16.7033H7.02667Z"
          fill="currentColor"
        />
      </svg>
    ),
    items: [
      { title: "Banner", path: "/promotion-management/banner" },
      { title: "Pop-up", path: "/promotion-management/popup" },
    ],
  },
  {
    title: "Books Management",
    path: "/books-management",
    icon: (
      <svg
        className="w-4 h-4"
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.43373 2.31326H7.51807C8.97204 2.31326 9.69903 2.31326 10.1507 2.76495C10.6024 3.21664 10.6024 3.94363 10.6024 5.3976V14.8434H11.759H15.2289H16C16.3194 14.8434 16.5783 15.1023 16.5783 15.4217C16.5783 15.7411 16.3194 16 16 16H0.578313C0.25892 16 0 15.7411 0 15.4217C0 15.1023 0.25892 14.8434 0.578313 14.8434H1.3494V5.3976C1.3494 3.94363 1.3494 3.21664 1.80109 2.76495C2.25278 2.31326 2.97976 2.31326 4.43373 2.31326ZM3.08434 4.62652C3.08434 4.30712 3.34326 4.0482 3.66265 4.0482H8.28916C8.60855 4.0482 8.86747 4.30712 8.86747 4.62652C8.86747 4.94591 8.60855 5.20483 8.28916 5.20483H3.66265C3.34326 5.20483 3.08434 4.94591 3.08434 4.62652ZM3.08434 6.93977C3.08434 6.62038 3.34326 6.36146 3.66265 6.36146H8.28916C8.60855 6.36146 8.86747 6.62038 8.86747 6.93977C8.86747 7.25916 8.60855 7.51808 8.28916 7.51808H3.66265C3.34326 7.51808 3.08434 7.25916 3.08434 6.93977ZM3.08434 9.25302C3.08434 8.93363 3.34326 8.67471 3.66265 8.67471H8.28916C8.60855 8.67471 8.86747 8.93363 8.86747 9.25302C8.86747 9.57242 8.60855 9.83134 8.28916 9.83134H3.66265C3.34326 9.83134 3.08434 9.57242 3.08434 9.25302ZM5.9759 12.5301C6.2953 12.5301 6.55422 12.7891 6.55422 13.1084V14.8434H5.39759V13.1084C5.39759 12.7891 5.65651 12.5301 5.9759 12.5301Z"
          fill="currentColor"
        />
        <path
          d="M10.6024 0H12.1446C13.5985 0 14.3255 0 14.7772 0.451691C15.2289 0.903382 15.2289 1.63037 15.2289 3.08434V14.8434H10.6024V5.39759C10.6024 3.94362 10.6024 3.21663 10.1507 2.76494C9.70922 2.32343 9.00467 2.31348 7.61523 2.31326V1.15662C7.68023 0.858021 7.78871 0.632741 7.96976 0.451691C8.42145 0 9.14844 0 10.6024 0Z"
          fill="currentColor"
        />
      </svg>
    ),
  },
  {
    title: "Publish Book",
    path: "/publish-book",
    icon: (
      <svg
        className="w-4 h-4"
        width="18"
        height="20"
        viewBox="0 0 18 20"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.41511 0.395136C8.79624 0.277997 9.20375 0.277997 9.58488 0.395136L12.5706 1.3128C14.1283 1.79155 15.6075 2.49541 16.9616 3.40207C18.0147 4.10725 17.5155 5.75 16.2481 5.75H1.75191C0.484457 5.75 -0.0147414 4.10726 1.03841 3.40207C2.39244 2.49541 3.87174 1.79155 5.42938 1.31281L8.41511 0.395136ZM9.1442 1.82894C9.05023 1.80006 8.94976 1.80006 8.85579 1.82894L5.87006 2.74661C4.68925 3.10953 3.55791 3.61457 2.50069 4.25H15.4993C14.4421 3.61457 13.3107 3.10953 12.1299 2.74661L9.1442 1.82894Z"
          fill="currentColor"
        />
        <path
          d="M1.25 19C1.25 18.5858 1.58579 18.25 2 18.25H16C16.4142 18.25 16.75 18.5858 16.75 19C16.75 19.4142 16.4142 19.75 16 19.75H2C1.58579 19.75 1.25 19.4142 1.25 19Z"
          fill="currentColor"
        />
        <path
          d="M3.25 15C3.25 15.4142 3.58579 15.75 4 15.75C4.41421 15.75 4.75 15.4142 4.75 15L4.75 9C4.75 8.58579 4.41421 8.25 4 8.25C3.58579 8.25 3.25 8.58579 3.25 9L3.25 15Z"
          fill="currentColor"
        />
        <path
          d="M9 15.75C8.58579 15.75 8.25 15.4142 8.25 15L8.25 9C8.25 8.58579 8.58579 8.25 9 8.25C9.41421 8.25 9.75 8.58579 9.75 9V15C9.75 15.4142 9.41421 15.75 9 15.75Z"
          fill="currentColor"
        />
        <path
          d="M13.25 15C13.25 15.4142 13.5858 15.75 14 15.75C14.4142 15.75 14.75 15.4142 14.75 15V9C14.75 8.58579 14.4142 8.25 14 8.25C13.5858 8.25 13.25 8.58579 13.25 9V15Z"
          fill="currentColor"
        />
      </svg>
    ),
  },
  {
    title: "Parish Management",
    path: "/parish-management",
    icon: (
      <svg
        className="w-4 h-4"
        width="22"
        height="21"
        viewBox="0 0 22 21"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.9997 19.249H20V7.97875C20 7.3585 19.7202 6.77875 19.2297 6.3985L17.9997 5.4385L17.9802 2.989C17.9802 2.4385 17.5302 1.999 16.9797 1.999H13.5702L12.23 0.95875C11.51 0.38875 10.49 0.38875 9.76999 0.95875L2.77024 6.3985C2.5304 6.58403 2.33627 6.82206 2.20275 7.09431C2.06923 7.36655 1.99987 7.66577 1.99999 7.969L1.94974 19.249H1.00024C0.589994 19.249 0.250244 19.5888 0.250244 19.999C0.250244 20.4093 0.589994 20.749 1.00024 20.749H20.9997C21.41 20.749 21.7497 20.4085 21.7497 19.999C21.7497 19.5895 21.41 19.249 20.9997 19.249ZM5.50024 10.7485V9.2485C5.50024 8.69875 5.95024 8.24875 6.49999 8.24875H8.50024C9.04999 8.24875 9.49999 8.69875 9.49999 9.2485V10.7485C9.49999 11.299 9.04999 11.749 8.50024 11.749H6.49999C5.95024 11.749 5.50024 11.299 5.50024 10.7485ZM13.4997 19.249H8.50024V16.4988C8.50024 15.6685 9.16999 14.9988 10.0002 14.9988H11.9997C12.83 14.9988 13.4997 15.6685 13.4997 16.4988V19.249ZM16.4997 10.7485C16.4997 11.299 16.0497 11.749 15.5 11.749H13.4997C12.95 11.749 12.5 11.299 12.5 10.7485V9.2485C12.5 8.69875 12.95 8.24875 13.4997 8.24875H15.5C16.0497 8.24875 16.4997 8.69875 16.4997 9.2485V10.7485Z"
          fill="currentColor"
        />
      </svg>
    ),
  },
  {
    title: "Events Management",
    path: "/events-management",
    icon: (
      <svg
        className="w-4 h-4"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.000244141 14.2499C0.00143502 15.2441 0.3969 16.1972 1.09989 16.9002C1.80289 17.6032 2.75601 17.9987 3.75019 17.9999H14.2501C15.2442 17.9987 16.1974 17.6032 16.9004 16.9002C17.6033 16.1972 17.9988 15.2441 18 14.2499V7.50002H0.000244141V14.2499ZM12.7501 10.875C13.0484 10.875 13.3346 10.9935 13.5456 11.2045C13.7565 11.4155 13.8751 11.7016 13.8751 12C13.8751 12.2983 13.7565 12.5845 13.5456 12.7954C13.3346 13.0064 13.0484 13.1249 12.7501 13.1249C12.4517 13.1249 12.1656 13.0064 11.9546 12.7954C11.7436 12.5845 11.6251 12.2983 11.6251 12C11.6251 11.7016 11.7436 11.4155 11.9546 11.2045C12.1656 10.9935 12.4517 10.875 12.7501 10.875ZM9.00012 10.875C9.29849 10.875 9.58463 10.9935 9.79561 11.2045C10.0066 11.4155 10.1251 11.7016 10.1251 12C10.1251 12.2983 10.0066 12.5845 9.79561 12.7954C9.58463 13.0064 9.29849 13.1249 9.00012 13.1249C8.70176 13.1249 8.41561 13.0064 8.20464 12.7954C7.99366 12.5845 7.87514 12.2983 7.87514 12C7.87514 11.7016 7.99366 11.4155 8.20464 11.2045C8.41561 10.9935 8.70176 10.875 9.00012 10.875ZM5.25017 10.875C5.54854 10.875 5.83468 10.9935 6.04566 11.2045C6.25663 11.4155 6.37516 11.7016 6.37516 12C6.37516 12.2983 6.25663 12.5845 6.04566 12.7954C5.83468 13.0064 5.54854 13.1249 5.25017 13.1249C4.95181 13.1249 4.66566 13.0064 4.45469 12.7954C4.24371 12.5845 4.12519 12.2983 4.12519 12C4.12519 11.7016 4.24371 11.4155 4.45469 11.2045C4.66566 10.9935 4.95181 10.875 5.25017 10.875Z"
          fill="currentColor"
        />
        <path
          d="M14.2501 1.5001H13.5001V0.750112C13.5001 0.551202 13.421 0.360439 13.2804 0.219789C13.1397 0.0791386 12.949 0.00012207 12.7501 0.00012207C12.5512 0.00012207 12.3604 0.0791386 12.2197 0.219789C12.0791 0.360439 12.0001 0.551202 12.0001 0.750112V1.5001H6.00016V0.750112C6.00016 0.551202 5.92115 0.360439 5.7805 0.219789C5.63985 0.0791386 5.44908 0.00012207 5.25017 0.00012207C5.05126 0.00012207 4.8605 0.0791386 4.71985 0.219789C4.5792 0.360439 4.50018 0.551202 4.50018 0.750112V1.5001H3.75019C2.75601 1.50129 1.80289 1.89676 1.09989 2.59975C0.3969 3.30275 0.00143502 4.25587 0.000244141 5.25005L0.000244141 6.00004H18V5.25005C17.9988 4.25587 17.6033 3.30275 16.9004 2.59975C16.1974 1.89676 15.2442 1.50129 14.2501 1.5001Z"
          fill="currentColor"
        />
      </svg>
    ),
  },
  {
    title: "Feedback Management",
    path: "/feedback-management",
    icon: (
      <svg
        className="w-4 h-4"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 8C0 4.22876 0 2.34315 1.17157 1.17157C2.34315 0 4.22876 0 8 0C11.7712 0 13.6569 0 14.8284 1.17157C16 2.34315 16 4.22876 16 8C16 11.7712 16 13.6569 14.8284 14.8284C13.6569 16 11.7712 16 8 16C4.22876 16 2.34315 16 1.17157 14.8284C0 13.6569 0 11.7712 0 8ZM4.8 10.6C4.46863 10.6 4.2 10.8686 4.2 11.2C4.2 11.5314 4.46863 11.8 4.8 11.8H11.2C11.5314 11.8 11.8 11.5314 11.8 11.2C11.8 10.8686 11.5314 10.6 11.2 10.6H4.8ZM4.46863 3.66863C4.93726 3.2 5.69151 3.2 7.2 3.2H8.8C10.3085 3.2 11.0627 3.2 11.5314 3.66863C12 4.13726 12 4.89151 12 6.4V6.6H13.6C13.9314 6.6 14.2 6.86863 14.2 7.2C14.2 7.53137 13.9314 7.8 13.6 7.8H2.4C2.06863 7.8 1.8 7.53137 1.8 7.2C1.8 6.86863 2.06863 6.6 2.4 6.6H4V6.4C4 4.89151 4 4.13726 4.46863 3.66863Z"
          fill="currentColor"
        />
      </svg>
    ),
  },
  {
    title: "Contact Management",
    path: "/contact-management",
    icon: (
      <svg
        className="w-4 h-4"
        width="13"
        height="16"
        viewBox="0 0 13 16"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.4 6.4C8.16731 6.4 9.6 4.96731 9.6 3.2C9.6 1.43269 8.16731 0 6.4 0C4.63269 0 3.2 1.43269 3.2 3.2C3.2 4.96731 4.63269 6.4 6.4 6.4Z"
          fill="currentColor"
        />
        <path
          d="M6.4 16C12.8 16 12.8 14.3882 12.8 12.4C12.8 10.4118 9.93462 8.8 6.4 8.8C2.86538 8.8 0 10.4118 0 12.4C0 14.3882 0 16 6.4 16Z"
          fill="currentColor"
        />
      </svg>
    ),
  },
  {
    title: "Settings Management",
    icon: (
      <svg
        className="w-4 h-4"
        width="19"
        height="20"
        viewBox="0 0 19 20"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.33919 15C1.67017 15.5745 2.21581 15.994 2.85609 16.1663C3.49637 16.3385 4.17884 16.2493 4.75336 15.9183L4.75586 15.9167L5.1267 15.7025C5.82673 16.3014 6.63133 16.7658 7.50003 17.0725V17.5C7.50003 18.163 7.76342 18.7989 8.23226 19.2678C8.7011 19.7366 9.33699 20 10 20C10.6631 20 11.299 19.7366 11.7678 19.2678C12.2366 18.7989 12.5 18.163 12.5 17.5V17.0725C13.3689 16.7653 14.1735 16.3003 14.8734 15.7008L15.2459 15.9158C15.8198 16.2356 16.4965 16.3168 17.1298 16.1418C17.7631 15.9669 18.3021 15.5498 18.6305 14.9807C18.9588 14.4116 19.05 13.7361 18.8845 13.1003C18.719 12.4645 18.31 11.9193 17.7459 11.5825L17.3759 11.3692C17.5425 10.4625 17.5425 9.53333 17.3759 8.6275L17.7459 8.41417C18.31 8.07739 18.719 7.53219 18.8845 6.89636C19.05 6.26053 18.9588 5.58511 18.6305 5.016C18.3021 4.4469 17.7631 4.02981 17.1298 3.85483C16.4965 3.67985 15.8198 3.76103 15.2459 4.08083L14.875 4.295C14.1743 3.69684 13.3691 3.23323 12.5 2.9275V2.5C12.5 1.83696 12.2366 1.20107 11.7678 0.732233C11.299 0.263392 10.6631 0 10 0C9.33699 0 8.7011 0.263392 8.23226 0.732233C7.76342 1.20107 7.50003 1.83696 7.50003 2.5V2.9275C6.63118 3.23462 5.82656 3.69965 5.1267 4.29917L4.7542 4.08333C4.46942 3.91333 4.15368 3.80165 3.82534 3.75479C3.49701 3.70793 3.16263 3.72682 2.84166 3.81037C2.5207 3.89393 2.21955 4.04047 1.95574 4.24147C1.69192 4.44248 1.47071 4.69394 1.30497 4.98122C1.13923 5.2685 1.03227 5.58587 0.990315 5.91487C0.948356 6.24387 0.972236 6.57792 1.06057 6.89761C1.14889 7.21729 1.29991 7.51622 1.50483 7.77701C1.70975 8.03779 1.96447 8.25523 2.25419 8.41667L2.62419 8.63C2.45762 9.5363 2.45762 10.4654 2.62419 11.3717L2.25419 11.585C1.68102 11.9175 1.26293 12.4635 1.09144 13.1035C0.919951 13.7436 1.00904 14.4255 1.33919 15ZM10 6.66667C10.8841 6.66667 11.7319 7.01786 12.3571 7.64298C12.9822 8.2681 13.3334 9.11594 13.3334 10C13.3334 10.8841 12.9822 11.7319 12.3571 12.357C11.7319 12.9821 10.8841 13.3333 10 13.3333C9.11597 13.3333 8.26813 12.9821 7.64301 12.357C7.01788 11.7319 6.6667 10.8841 6.6667 10C6.6667 9.11594 7.01788 8.2681 7.64301 7.64298C8.26813 7.01786 9.11597 6.66667 10 6.66667Z"
          fill="currentColor"
        />
      </svg>
    ),
    items: [
      { title: "Admin Email", path: "/settings/admin-email" },
      { title: "General Countries", path: "/settings/general-countries" },
      {
        title: "Parish Categories",
        path: "/settings/parish-categories",
      },
      { title: "Parish Countries", path: "/settings/parish-countries" },
      { title: "Region", path: "/settings/region" },
      { title: "Province", path: "/settings/province" },
      { title: "Book Category", path: "/settings/book-category" },
      { title: "Book Language", path: "/settings/book-language" },
      { title: "About Kirista", path: "/settings/about-kirista" },
      { title: "About RCCG", path: "/settings/about-rccg" },
      { title: "About RCCG Structure", path: "/settings/about-rccg-structure" },
      {
        title: "About RCCG Continent 2",
        path: "/settings/about-rccg-continent2",
      },
      { title: "Terms", path: "/settings/terms" },
      { title: "Privacy", path: "/settings/privacy" },
      { title: "FAQ", path: "/settings/faq" },
    ],
  },
];

// Locations
export const locations = [
  "Wuse, Abuja",
  "Wuse, Abuja",
  "Wuse, Abuja",
  "Wuse, Abuja",
  "Wuse, Abuja",
  "Wuse, Abuja",
  "Wuse, Abuja",
  "Wuse, Abuja",
  "Wuse, Abuja",
];

// Notifications
export const notificationIcons = {
  user: <FaUsers className="text-base text-blue-500" />,
  contact: (
    <svg
      width="13"
      height="16"
      viewBox="0 0 13 16"
      fill="rgb(59 130 246)"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.4 6.4C8.16731 6.4 9.6 4.96731 9.6 3.2C9.6 1.43269 8.16731 0 6.4 0C4.63269 0 3.2 1.43269 3.2 3.2C3.2 4.96731 4.63269 6.4 6.4 6.4Z"
        fill="rgb(59 130 246)"
      />
      <path
        d="M6.4 16C12.8 16 12.8 14.3882 12.8 12.4C12.8 10.4118 9.93462 8.8 6.4 8.8C2.86538 8.8 0 10.4118 0 12.4C0 14.3882 0 16 6.4 16Z"
        fill="rgb(59 130 246)"
      />
    </svg>
  ),
  feedback: <MdFeedback className="text-base text-blue-500" />,
};

// Dashboard Analytics
export const dashboardCards = [
  {
    title: "Total_Countries",
    icon: (
      <svg
        className="w-5 h-5"
        width="38"
        height="38"
        viewBox="0 0 38 38"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19 37.2083C29.0562 37.2083 37.2083 29.0561 37.2083 19C37.2083 8.94377 29.0562 0.791626 19 0.791626C8.9438 0.791626 0.791656 8.94377 0.791656 19C0.791656 29.0561 8.9438 37.2083 19 37.2083Z"
          fill="#CBEAFB"
        />
        <path
          d="M0.791664 19C0.789328 21.5795 1.33657 24.13 2.39694 26.4816C3.45732 28.8332 5.00649 30.9319 6.94133 32.638L8.55 30.2258C8.55 30.2258 9.6995 29.8941 9.94729 29.4492C10.7231 28.0527 9.34562 25.6215 9.34562 25.6215C9.31718 25.0388 9.22426 24.461 9.06854 23.8988C8.86112 23.3818 7.41317 22.6733 7.41317 22.6733C7.41317 22.6733 6.01666 20.3972 6.01666 19C5.99227 18.4521 6.18504 17.9167 6.5531 17.5101C6.92115 17.1035 7.43476 16.8585 7.98237 16.8284C8.44434 16.7305 8.8808 16.5373 9.26385 16.2611C9.64689 15.9849 9.96811 15.6319 10.207 15.2245C10.207 15.2245 11.966 14.7582 12.3793 14.037C12.7925 13.3158 11.9146 10.7318 11.9146 10.7318C12.0772 10.0492 12.0712 9.33735 11.8972 8.65762C11.6086 8.02913 11.1591 7.48809 10.5941 7.08933C10.14 5.95392 9.44908 4.92835 8.56741 4.08099C6.16544 5.75749 4.20407 7.98949 2.85023 10.587C1.49639 13.1846 0.790168 16.0708 0.791664 19Z"
          fill="#387DE5"
        />
        <path
          d="M19 0.791637C18.5092 0.791637 18.0247 0.81697 17.5441 0.85497C17.3858 1.34501 16.5696 2.60297 16.7754 3.1706C16.9812 3.73822 18.6714 4.26626 18.6714 4.26626C18.6714 4.26626 18.2234 6.01664 19 6.63651C19.7766 7.25639 21.0179 6.42989 21.4827 6.58505C21.9474 6.74022 21.8444 9.7913 21.8444 9.7913C21.8444 9.7913 23.3447 11.4467 24.8195 11.6541C26.2944 11.8615 28.5404 9.35826 28.5404 9.35826C30.1913 8.98275 31.8069 8.46627 33.3695 7.81451C31.6687 5.6254 29.4896 3.85444 26.9989 2.63718C24.5083 1.41992 21.7722 0.78863 19 0.791637Z"
          fill="#387DE5"
        />
        <path
          d="M32.3459 20.1875C32.76 21.1707 31.5685 23.6803 30.5868 24.1704C29.5819 24.6266 28.706 25.3251 28.0377 26.2034C27.6751 26.7726 27.1993 29.1199 26.0102 29.5854C24.8211 30.0509 22.0004 32.7061 20.5002 32.2921C19 31.878 19 28.3108 20.0347 26.7069C20.6522 25.7497 19.931 23.655 19.8764 22.9314C19.8218 22.2078 17.6542 20.862 17.6542 20.1384C17.6542 19 20.1368 15.9996 20.1368 15.9996C20.1368 15.9996 22.1714 15.3274 22.7921 15.4826C23.4196 15.7108 24.021 16.0054 24.586 16.3614C25.68 16.443 26.7583 16.669 27.793 17.0335L28.9805 18.1196C28.9805 18.1196 31.9319 19.2066 32.3459 20.1875Z"
          fill="#387DE5"
        />
      </svg>
    ),
    colSpan: "col-span-2",
  },
  {
    title: "Total_Users",
    icon: (
      <svg
        className="w-4 h-4 text-blue-500"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="5.84074" cy="3.36808" r="3.36808" fill="currentColor" />
        <ellipse
          cx="5.89415"
          cy="12.6319"
          rx="5.89415"
          ry="3.36808"
          fill="currentColor"
        />
        <path
          d="M15.7029 12.0853C15.7029 13.4804 13.9889 14.6113 11.8962 14.6113C12.5128 13.9374 12.9367 13.0915 12.9367 12.0864C12.9367 11.0802 12.5118 10.2335 11.8941 9.55924C13.9868 9.55924 15.7029 10.6902 15.7029 12.0853Z"
          fill="currentColor"
        />
        <path
          d="M13.1768 2.82327C13.1768 4.21838 12.0459 5.34934 10.6508 5.34934C10.3465 5.34934 10.0549 5.29556 9.78479 5.197C10.1831 4.49636 10.4106 3.68591 10.4106 2.82233C10.4106 1.95939 10.1835 1.14951 9.78567 0.449224C10.0555 0.350866 10.3469 0.297211 10.6508 0.297211C12.0459 0.297211 13.1768 1.42817 13.1768 2.82327Z"
          fill="currentColor"
        />
      </svg>
    ),
    colSpan: "col-span-2 sm:col-span-1",
  },
  {
    title: "Parish_Countries",
    icon: <HiGlobe className="text-xl text-blue-500" />,
    colSpan: "col-span-2 sm:col-span-1",
  },
  {
    title: "Total_Android_Users",
    icon: (
      <svg
        className="w-4 h-4 text-blue-500"
        width="20"
        height="24"
        viewBox="0 0 20 24"
        fill="currentIcon"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.00003 18C4.00003 18.55 4.45003 19 5.00003 19H6.00003V22.5C6.00003 23.33 6.67003 24 7.50003 24C8.33003 24 9.00003 23.33 9.00003 22.5V19H11V22.5C11 23.33 11.67 24 12.5 24C13.33 24 14 23.33 14 22.5V19H15C15.55 19 16 18.55 16 18V8H4.00003V18ZM1.50003 8C0.670031 8 3.05176e-05 8.67 3.05176e-05 9.5V16.5C3.05176e-05 17.33 0.670031 18 1.50003 18C2.33003 18 3.00003 17.33 3.00003 16.5V9.5C3.00003 8.67 2.33003 8 1.50003 8ZM18.5 8C17.67 8 17 8.67 17 9.5V16.5C17 17.33 17.67 18 18.5 18C19.33 18 20 17.33 20 16.5V9.5C20 8.67 19.33 8 18.5 8ZM13.53 2.16L14.83 0.86C15.03 0.66 15.03 0.35 14.83 0.15C14.63 -0.05 14.32 -0.05 14.12 0.15L12.64 1.63C11.8217 1.21559 10.9173 0.999759 10 1C9.04003 1 8.14003 1.23 7.34003 1.63L5.85003 0.15C5.65003 -0.05 5.34003 -0.05 5.14003 0.15C4.94003 0.35 4.94003 0.66 5.14003 0.86L6.45003 2.17C5.69059 2.72569 5.07293 3.45267 4.64723 4.29191C4.22153 5.13115 3.99979 6.05897 4.00003 7H16C16 5.01 15.03 3.25 13.53 2.16ZM8.00003 5H7.00003V4H8.00003V5ZM13 5H12V4H13V5Z"
          fill="currentIcon"
        />
      </svg>
    ),
    colSpan: "col-span-2 sm:col-span-1",
  },
  {
    title: "Parish_Categories",
    icon: (
      <svg
        className="w-5 h-5 text-blue-500"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
      >
        <path d="M10 3H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm10 10h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1zM17 3c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4zM7 13c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4z"></path>
      </svg>
    ),
    colSpan: "col-span-2 sm:col-span-1",
  },
  {
    title: "Total_IOS_Users",
    icon: (
      <svg
        className="w-4 h-4"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.1 19.16C19.69 18.26 19.91 17.8 20.36 16.79C17.04 15.53 16.51 10.8 19.79 8.99C18.79 7.73 17.38 7 16.05 7C15.09 7 14.43 7.25 13.84 7.48C13.34 7.67 12.89 7.84 12.33 7.84C11.73 7.84 11.2 7.65 10.64 7.45C10.04 7.23 9.39999 7 8.59999 7C7.10999 7 5.51999 7.91 4.50999 9.47C3.08999 11.67 3.33999 15.79 5.62999 19.31C6.44999 20.57 7.54998 21.98 8.97998 22C9.57998 22.01 9.96999 21.83 10.4 21.64C10.89 21.42 11.42 21.18 12.35 21.18C13.28 21.17 13.8 21.42 14.29 21.64C14.71 21.83 15.09 22.01 15.68 22C17.12 21.98 18.28 20.42 19.1 19.16Z"
          fill="#387DE5"
        />
        <path
          opacity="0.4"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.84 2C16 3.1 15.55 4.19 14.96 4.95C14.33 5.77 13.23 6.41 12.17 6.37C11.98 5.31 12.47 4.22 13.07 3.49C13.74 2.69 14.87 2.07 15.84 2Z"
          fill="#387DE5"
        />
      </svg>
    ),
    colSpan: "col-span-2 sm:col-span-1",
  },
  {
    title: "Total_Regions",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        strokeWidth="1.5"
        stroke="currentColor"
        className="w-5 h-5 text-blue-500"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M2.25 7.125C2.25 6.504 2.754 6 3.375 6h6c.621 0 1.125.504 1.125 1.125v3.75c0 .621-.504 1.125-1.125 1.125h-6a1.125 1.125 0 01-1.125-1.125v-3.75zM14.25 8.625c0-.621.504-1.125 1.125-1.125h5.25c.621 0 1.125.504 1.125 1.125v8.25c0 .621-.504 1.125-1.125 1.125h-5.25a1.125 1.125 0 01-1.125-1.125v-8.25zM3.75 16.125c0-.621.504-1.125 1.125-1.125h5.25c.621 0 1.125.504 1.125 1.125v2.25c0 .621-.504 1.125-1.125 1.125h-5.25a1.125 1.125 0 01-1.125-1.125v-2.25z"
        />
      </svg>
    ),
    colSpan: "col-span-2 sm:col-span-1",
  },
  {
    title: "Total_Books",
    icon: (
      <svg
        className="w-4 h-4 text-blue-500 mt-0.5"
        width="24"
        height="22"
        viewBox="0 0 24 22"
        fill="currentIcon"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22.2 1.163C21.6299 0.687364 20.9611 0.344649 20.242 0.159742C19.523 -0.0251646 18.7718 -0.0476213 18.043 0.0940027L16.279 0.526003C15.3584 0.694697 14.5262 1.18084 13.9271 1.89983C13.3279 2.61881 12.9999 3.52511 13 4.461V19.928C12.3369 20.025 11.6631 20.025 11 19.928V4.461C11.0033 3.53374 10.6828 2.63441 10.0939 1.91821C9.50493 1.202 8.68444 0.713853 7.774 0.538003L5.9 0.0820028C5.17916 -0.0499034 4.43813 -0.0217471 3.72938 0.164479C3.02062 0.350704 2.36146 0.690446 1.79857 1.15966C1.23567 1.62887 0.782786 2.21607 0.471982 2.87971C0.161178 3.54335 4.88124e-05 4.26719 0 5L0 15.793C5.74558e-05 16.9638 0.410977 18.0975 1.16113 18.9964C1.91129 19.8953 2.95311 20.5024 4.105 20.712L10.391 21.855C11.4549 22.0484 12.5451 22.0484 13.609 21.855L19.9 20.712C21.051 20.5014 22.0916 19.8938 22.8408 18.995C23.5899 18.0962 24.0002 16.9631 24 15.793V5C24.0005 4.26745 23.8394 3.5438 23.5283 2.8806C23.2171 2.21739 22.7636 1.63094 22.2 1.163Z"
          fill="currentIcon"
        />
      </svg>
    ),
    colSpan: "col-span-2 sm:col-span-1",
  },
  {
    title: "Total_Provinces",
    icon: <FaReadme className="text-lg text-blue-500" />,
    colSpan: "col-span-2 sm:col-span-1",
  },
  {
    title: "Contacts",
    icon: (
      <svg
        className="w-4 h-4 text-blue-500"
        width="13"
        height="16"
        viewBox="0 0 13 16"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.4 6.4C8.16731 6.4 9.6 4.96731 9.6 3.2C9.6 1.43269 8.16731 0 6.4 0C4.63269 0 3.2 1.43269 3.2 3.2C3.2 4.96731 4.63269 6.4 6.4 6.4Z"
          fill="currentColor"
        />
        <path
          d="M6.4 16C12.8 16 12.8 14.3882 12.8 12.4C12.8 10.4118 9.93462 8.8 6.4 8.8C2.86538 8.8 0 10.4118 0 12.4C0 14.3882 0 16 6.4 16Z"
          fill="currentColor"
        />
      </svg>
    ),
    colSpan: "col-span-2 sm:col-span-1",
  },
  {
    title: "Total_Parishes",
    icon: (
      <svg
        className="w-5 h-5 text-blue-500"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path d="M10 22v-4a2 2 0 0 1 4 0v4h4V12a1 1 0 0 0-.485-.857L13 8.434V6h2V4h-2V2h-2v2H9v2h2v2.434l-4.515 2.709A1 1 0 0 0 6 12v10h4zm-7 0h2v-8.118l-2.447 1.224A.998.998 0 0 0 2 16v5a1 1 0 0 0 1 1zm18.447-6.895L19 13.882V22h2a1 1 0 0 0 1-1v-5c0-.379-.214-.725-.553-.895z"></path>
      </svg>
    ),
    colSpan: "col-span-2 sm:col-span-1",
  },
  {
    title: "Feedbacks",
    icon: <MdFeedback className="text-lg text-blue-500" />,
    colSpan: "col-span-2 sm:col-span-1",
  },
  {
    title: "Total_Events",
    icon: (
      <svg
        className="w-4 h-4 text-blue-500"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.000244141 14.2499C0.00143502 15.2441 0.3969 16.1972 1.09989 16.9002C1.80289 17.6032 2.75601 17.9987 3.75019 17.9999H14.2501C15.2442 17.9987 16.1974 17.6032 16.9004 16.9002C17.6033 16.1972 17.9988 15.2441 18 14.2499V7.50002H0.000244141V14.2499ZM12.7501 10.875C13.0484 10.875 13.3346 10.9935 13.5456 11.2045C13.7565 11.4155 13.8751 11.7016 13.8751 12C13.8751 12.2983 13.7565 12.5845 13.5456 12.7954C13.3346 13.0064 13.0484 13.1249 12.7501 13.1249C12.4517 13.1249 12.1656 13.0064 11.9546 12.7954C11.7436 12.5845 11.6251 12.2983 11.6251 12C11.6251 11.7016 11.7436 11.4155 11.9546 11.2045C12.1656 10.9935 12.4517 10.875 12.7501 10.875ZM9.00012 10.875C9.29849 10.875 9.58463 10.9935 9.79561 11.2045C10.0066 11.4155 10.1251 11.7016 10.1251 12C10.1251 12.2983 10.0066 12.5845 9.79561 12.7954C9.58463 13.0064 9.29849 13.1249 9.00012 13.1249C8.70176 13.1249 8.41561 13.0064 8.20464 12.7954C7.99366 12.5845 7.87514 12.2983 7.87514 12C7.87514 11.7016 7.99366 11.4155 8.20464 11.2045C8.41561 10.9935 8.70176 10.875 9.00012 10.875ZM5.25017 10.875C5.54854 10.875 5.83468 10.9935 6.04566 11.2045C6.25663 11.4155 6.37516 11.7016 6.37516 12C6.37516 12.2983 6.25663 12.5845 6.04566 12.7954C5.83468 13.0064 5.54854 13.1249 5.25017 13.1249C4.95181 13.1249 4.66566 13.0064 4.45469 12.7954C4.24371 12.5845 4.12519 12.2983 4.12519 12C4.12519 11.7016 4.24371 11.4155 4.45469 11.2045C4.66566 10.9935 4.95181 10.875 5.25017 10.875Z"
          fill="currentColor"
        />
        <path
          d="M14.2501 1.5001H13.5001V0.750112C13.5001 0.551202 13.421 0.360439 13.2804 0.219789C13.1397 0.0791386 12.949 0.00012207 12.7501 0.00012207C12.5512 0.00012207 12.3604 0.0791386 12.2197 0.219789C12.0791 0.360439 12.0001 0.551202 12.0001 0.750112V1.5001H6.00016V0.750112C6.00016 0.551202 5.92115 0.360439 5.7805 0.219789C5.63985 0.0791386 5.44908 0.00012207 5.25017 0.00012207C5.05126 0.00012207 4.8605 0.0791386 4.71985 0.219789C4.5792 0.360439 4.50018 0.551202 4.50018 0.750112V1.5001H3.75019C2.75601 1.50129 1.80289 1.89676 1.09989 2.59975C0.3969 3.30275 0.00143502 4.25587 0.000244141 5.25005L0.000244141 6.00004H18V5.25005C17.9988 4.25587 17.6033 3.30275 16.9004 2.59975C16.1974 1.89676 15.2442 1.50129 14.2501 1.5001Z"
          fill="currentColor"
        />
      </svg>
    ),
    colSpan: "col-span-2 sm:col-span-1",
  },
];

// Contact List on Dashboard
export const contactListItems = [
  {
    title: "Jerry",
    photoUrl: "https://i.pravatar.cc/30",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut lobortis, nisl sed finibus rhoncus, risus dolor egestas velit, ut ornare urna risus non nulla. Etiam tempor, est eu euismod ultricies, ipsum sapien accumsan lectus, vitae euismod massa sapien sed dui.",
  },
  {
    title: "Jerry",
    photoUrl: "https://i.pravatar.cc/30",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut lobortis, nisl sed finibus rhoncus, risus dolor egestas velit, ut ornare urna risus non nulla. Etiam tempor, est eu euismod ultricies, ipsum sapien accumsan lectus, vitae euismod massa sapien sed dui.",
  },
  {
    title: "Jerry",
    photoUrl: "https://i.pravatar.cc/30",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut lobortis, nisl sed finibus rhoncus, risus dolor egestas velit, ut ornare urna risus non nulla. Etiam tempor, est eu euismod ultricies, ipsum sapien accumsan lectus, vitae euismod massa sapien sed dui.",
  },
  {
    title: "Jerry",
    photoUrl: "https://i.pravatar.cc/30",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut lobortis, nisl sed finibus rhoncus, risus dolor egestas velit, ut ornare urna risus non nulla. Etiam tempor, est eu euismod ultricies, ipsum sapien accumsan lectus, vitae euismod massa sapien sed dui.",
  },
  {
    title: "Jerry",
    photoUrl: "https://i.pravatar.cc/30",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut lobortis, nisl sed finibus rhoncus, risus dolor egestas velit, ut ornare urna risus non nulla. Etiam tempor, est eu euismod ultricies, ipsum sapien accumsan lectus, vitae euismod massa sapien sed dui.",
  },
  {
    title: "Jerry",
    photoUrl: "https://i.pravatar.cc/30",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut lobortis, nisl sed finibus rhoncus, risus dolor egestas velit, ut ornare urna risus non nulla. Etiam tempor, est eu euismod ultricies, ipsum sapien accumsan lectus, vitae euismod massa sapien sed dui.",
  },
];

// Feedbacks list on Dashboard
export const feedbackListItems = [
  {
    title: "Jerry",
    photoUrl: "https://i.pravatar.cc/30",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut lobortis, nisl sed finibus rhoncus, risus dolor egestas velit, ut ornare urna risus non nulla. Etiam tempor, est eu euismod ultricies, ipsum sapien accumsan lectus, vitae euismod massa sapien sed dui.",
  },
  {
    title: "Jerry",
    photoUrl: "https://i.pravatar.cc/30",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut lobortis, nisl sed finibus rhoncus, risus dolor egestas velit, ut ornare urna risus non nulla. Etiam tempor, est eu euismod ultricies, ipsum sapien accumsan lectus, vitae euismod massa sapien sed dui.",
  },
  {
    title: "Jerry",
    photoUrl: "https://i.pravatar.cc/30",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut lobortis, nisl sed finibus rhoncus, risus dolor egestas velit, ut ornare urna risus non nulla. Etiam tempor, est eu euismod ultricies, ipsum sapien accumsan lectus, vitae euismod massa sapien sed dui.",
  },
  {
    title: "Jerry",
    photoUrl: "https://i.pravatar.cc/30",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut lobortis, nisl sed finibus rhoncus, risus dolor egestas velit, ut ornare urna risus non nulla. Etiam tempor, est eu euismod ultricies, ipsum sapien accumsan lectus, vitae euismod massa sapien sed dui.",
  },
  {
    title: "Jerry",
    photoUrl: "https://i.pravatar.cc/30",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut lobortis, nisl sed finibus rhoncus, risus dolor egestas velit, ut ornare urna risus non nulla. Etiam tempor, est eu euismod ultricies, ipsum sapien accumsan lectus, vitae euismod massa sapien sed dui.",
  },
  {
    title: "Jerry",
    photoUrl: "https://i.pravatar.cc/30",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut lobortis, nisl sed finibus rhoncus, risus dolor egestas velit, ut ornare urna risus non nulla. Etiam tempor, est eu euismod ultricies, ipsum sapien accumsan lectus, vitae euismod massa sapien sed dui.",
  },
];

// Total Users
export const users = [
  {
    _ID: "IOS757575",
    "S/N": 637,
    Name: "Neil Sims",
    Email: "neil.sims@flowbite.com",
    "Phone Number": 3873687368723,
    _Password: "$admin1234",
    _Country: "Nigeria",
    Status: "ACTIVE",
  },
  {
    _ID: "IOS466464",
    "S/N": 63,
    Name: "Bonnie Green",
    Email: "bonnie@flowbite.com",
    "Phone Number": 3873687368723,
    _Password: "$admin1234",
    _Country: "Nigeria",
    Status: "INACTIVE",
  },
  {
    _ID: "IOS123212",
    "S/N": 6,
    Name: "Jese Leos",
    Email: "jese@flowbite.com",
    "Phone Number": 3873687368723,
    _Password: "$admin1234",
    _Country: "Nigeria",
    Status: "ACTIVE",
  },
  {
    _ID: "IOS838383",
    "S/N": 4,
    Name: "Thomas Lean",
    Email: "thomes@flowbite.com",
    "Phone Number": 3873687368723,
    _Password: "$admin1234",
    _Country: "Benin",
    Status: "ACTIVE",
  },
  {
    _ID: "IOS445544",
    "S/N": 74,
    Name: "Leslie Livingston",
    Email: "leslie@flowbite.com",
    "Phone Number": 3873687368723,
    _Password: "$admin1234",
    _Country: "Nigeria",
    Status: "ACTIVE",
  },
];

// Banners
export const banners = [
  {
    "S/N": 637,
    _Platform: "Android",
    Title: "Pellentesque facilisis dolor",
    _Tag: "Sollicitudin",
    "App Page": "www.example.com",
    "Media File": "https://loremflickr.com/320/240",
    Status: "ACTIVE",
    "_Expiry Date": "2/5/2023",
  },
  {
    "S/N": 63,
    _Platform: "IOS",
    Title: "Pellentesque facilisis dolor",
    _Tag: "Sollicitudin",
    "App Page": "www.example.com",
    "Media File": "https://loremflickr.com/320/240",
    Status: "INACTIVE",
    "_Expiry Date": "2/5/2023",
  },
  {
    "S/N": 6,
    _Platform: "Android",
    Title: "Pellentesque facilisis dolor",
    _Tag: "Sollicitudin",
    "App Page": "www.example.com",
    "Media File": "https://loremflickr.com/320/240",
    Status: "ACTIVE",
    "_Expiry Date": "2/5/2023",
  },
  {
    "S/N": 4,
    _Platform: "IOS",
    Title: "Pellentesque facilisis dolor",
    _Tag: "Sollicitudin",
    "App Page": "www.example.com",
    "Media File": "https://loremflickr.com/320/240",
    Status: "ACTIVE",
    "_Expiry Date": "2/5/2023",
  },
  {
    "S/N": 74,
    _Platform: "Android",
    Title: "Pellentesque facilisis dolor",
    _Tag: "Sollicitudin",
    "App Page": "www.example.com",
    "Media File": "https://loremflickr.com/320/240",
    Status: "ACTIVE",
    "_Expiry Date": "2/5/2023",
  },
];

// Popups
export const popups = [
  {
    "S/N": 637,
    _Platform: "Android",
    Title: "Pellentesque facilisis dolor",
    _Tag: "Sollicitudin",
    "App Page": "www.example.com",
    "Media File": "https://loremflickr.com/320/240",
    Status: "ACTIVE",
    "_Expiry Date": "2/5/2023",
  },
  {
    "S/N": 63,
    _Platform: "IOS",
    Title: "Pellentesque facilisis dolor",
    _Tag: "Sollicitudin",
    "App Page": "www.example.com",
    "Media File": "https://loremflickr.com/320/240",
    Status: "INACTIVE",
    "_Expiry Date": "2/5/2023",
  },
  {
    "S/N": 6,
    _Platform: "Android",
    Title: "Pellentesque facilisis dolor",
    _Tag: "Sollicitudin",
    "App Page": "www.example.com",
    "Media File": "https://loremflickr.com/320/240",
    Status: "ACTIVE",
    "_Expiry Date": "2/5/2023",
  },
  {
    "S/N": 4,
    _Platform: "IOS",
    Title: "Pellentesque facilisis dolor",
    _Tag: "Sollicitudin",
    "App Page": "www.example.com",
    "Media File": "https://loremflickr.com/320/240",
    Status: "ACTIVE",
    "_Expiry Date": "2/5/2023",
  },
  {
    "S/N": 374,
    _Platform: "Android",
    Title: "Pellentesque facilisis dolor",
    _Tag: "Sollicitudin",
    "App Page": "www.example.com",
    "Media File": "https://loremflickr.com/320/240",
    Status: "ACTIVE",
    "_Expiry Date": "2/5/2023",
  },
];

// Books
export const books = [
  {
    "S/N": 637,
    Image: "https://loremflickr.com/g/320/240/cover",
    Title: "Pellentesque facilisis dolor",
    Author: "Pretium Sed",
    Category: "story",
    _Language: "Spanish",
    _Country: "Nigeria",
    _About:
      "Pellentesque vitae facilisis dolor. In ac metus vitae arcu sollicitudin pretium sed quis augue.",
    "_Released Year": 2020,
    _Downloads: "1684",
    _Reads: "8048",
    Status: "ACTIVE",
    _Featured: "Yes",
    ePUB_Type: "file",
  },
  {
    "S/N": 634,
    Image: "https://loremflickr.com/g/320/240/cover",
    Title: "Pellentesque facilisis dolor",
    Author: "Pretium Sed",
    Category: "story",
    _Language: "Spanish",
    _Country: "Benin",
    _About:
      "Pellentesque vitae facilisis dolor. In ac metus vitae arcu sollicitudin pretium sed quis augue.",
    "_Released Year": 2020,
    "_Downloads/Reads": "1684/8048",
    Status: "INACTIVE",
    _Featured: "No",
    ePUB_Type: "html",
  },
  {
    "S/N": 374,
    Image: "https://loremflickr.com/g/320/240/cover",
    Title: "Harry Potter",
    Author: "J. K. Rowling",
    Category: "story",
    _Language: "English",
    _Country: "Nigeria",
    _About:
      "Pellentesque vitae facilisis dolor. In ac metus vitae arcu sollicitudin pretium sed quis augue.",
    "_Released Year": 2020,
    "_Downloads/Reads": "1684/8048",
    Status: "ACTIVE",
    _Featured: "Yes",
    ePUB_Type: "file",
  },
  {
    "S/N": 674,
    Image: "https://loremflickr.com/g/320/240/cover",
    Title: "Pellentesque facilisis dolor",
    Author: "Pretium Sed",
    Category: "story",
    _Language: "Spanish",
    _Country: "Benin",
    _About:
      "Pellentesque vitae facilisis dolor. In ac metus vitae arcu sollicitudin pretium sed quis augue.",
    "_Released Year": 2020,
    "_Downloads/Reads": "1684/8048",
    Status: "ACTIVE",
    _Featured: "No",
    ePUB_Type: "html",
  },
  {
    "S/N": 63,
    Image: "https://loremflickr.com/g/320/240/cover",
    Title: "Pellentesque facilisis dolor",
    Author: "Pretium Sed",
    Category: "story",
    _Language: "Spanish",
    _Country: "Nigeria",
    _About:
      "Pellentesque vitae facilisis dolor. In ac metus vitae arcu sollicitudin pretium sed quis augue.",
    "_Released Year": 2020,
    "_Downloads/Reads": "1684/8048",
    Status: "ACTIVE",
    _Featured: "Yes",
    ePUB_Type: "file",
  },
];

// Parishes
export const parishes = [
  {
    "S/N": 6374,
    Country: "Nigeria",
    _Region: "Southie",
    _Province: "Taxes",
    Image: "https://loremflickr.com/g/320/240/cover",
    Title: "Lorem ipsum",
    _About:
      "Pellentesque vitae facilisis dolor. In ac metus vitae arcu sollicitudin pretium sed quis augue. ",
    _Location: "Donec ultricies vitae metus quis convallis.",
    _Address:
      "Suspendisse potenti. Donec mi magna, efficitur eu nibh sit amet.",
    _Map: "40.748440°, -73.984559°",
    Email: "example@gmail.com",
    _Phone: "+92 897 5498 984",
    _Website: "www.example.com",
    Status: "ACTIVE",
  },
  {
    "S/N": 674,
    Country: "Benin",
    _Region: "Southie",
    _Province: "Taxes",
    Image: "https://loremflickr.com/g/320/240/cover",
    Title: "Lorem ipsum",
    _About:
      "Pellentesque vitae facilisis dolor. In ac metus vitae arcu sollicitudin pretium sed quis augue. ",
    _Location: "Donec ultricies vitae metus quis convallis.",
    _Address:
      "Suspendisse potenti. Donec mi magna, efficitur eu nibh sit amet.",
    _Map: "40.748440°, -73.984559°",
    Email: "example@gmail.com",
    _Phone: "+92 897 5498 984",
    _Website: "www.example.com",
    Status: "INACTIVE",
  },
  {
    "S/N": 634,
    Country: "Nigeria",
    _Region: "Southie",
    _Province: "Taxes",
    Image: "https://loremflickr.com/g/320/240/cover",
    Title: "Lorem ipsum",
    _About:
      "Pellentesque vitae facilisis dolor. In ac metus vitae arcu sollicitudin pretium sed quis augue. ",
    _Location: "Donec ultricies vitae metus quis convallis.",
    _Address:
      "Suspendisse potenti. Donec mi magna, efficitur eu nibh sit amet.",
    _Map: "40.748440°, -73.984559°",
    Email: "example@gmail.com",
    _Phone: "+92 897 5498 984",
    _Website: "www.example.com",
    Status: "ACTIVE",
  },
  {
    "S/N": 637,
    Country: "Benin",
    _Region: "Southie",
    _Province: "Taxes",
    Image: "https://loremflickr.com/g/320/240/cover",
    Title: "Lorem ipsum",
    _About:
      "Pellentesque vitae facilisis dolor. In ac metus vitae arcu sollicitudin pretium sed quis augue. ",
    _Location: "Donec ultricies vitae metus quis convallis.",
    _Address:
      "Suspendisse potenti. Donec mi magna, efficitur eu nibh sit amet.",
    _Map: "40.748440°, -73.984559°",
    Email: "example@gmail.com",
    _Phone: "+92 897 5498 984",
    _Website: "www.example.com",
    Status: "ACTIVE",
  },
  {
    "S/N": 374,
    Country: "Nigeria",
    _Region: "Southie",
    _Province: "Taxes",
    Image: "https://loremflickr.com/g/320/240/cover",
    Title: "Lorem jack",
    _About:
      "Pellentesque vitae facilisis dolor. In ac metus vitae arcu sollicitudin pretium sed quis augue. ",
    _Location: "Donec ultricies vitae metus quis convallis.",
    _Address:
      "Suspendisse potenti. Donec mi magna, efficitur eu nibh sit amet.",
    _Map: "40.748440°, -73.984559°",
    Email: "example@gmail.com",
    _Phone: "+92 897 5498 984",
    _Website: "www.example.com",
    Status: "ACTIVE",
  },
];

// Events
export const events = [
  {
    "S/N": 6374,
    Image: "https://loremflickr.com/g/320/240/cover",
    Title: "Lorem ipsum",
    _About: "Suspendisse potenti. Donec mi magna, efficitur eu nibh sit amet",
    "Date (Start/End)": "2/5/2020 - 6/2/2023",
    "Time (Start/End)": "5:00 PM - 12:00 AM",
    _Location: "Donec ultricies vitae metus quis convallis.",
    _Address: "In ac metus vitae arcu sollicitudin pretium sed quis augue.",
    _Map: "40.748440°, -73.984559°",
    Status: "ACTIVE",
    _Featured: "Yes",
  },
  {
    "S/N": 674,
    Image: "https://loremflickr.com/g/320/240/cover",
    Title: "Lorem ipsum",
    _About: "Suspendisse potenti. Donec mi magna, efficitur eu nibh sit amet",
    "Date (Start/End)": "2/5/2020 - 6/2/2023",
    "Time (Start/End)": "5:00 PM - 12:00 AM",
    _Location: "Donec ultricies vitae metus quis convallis.",
    _Address: "In ac metus vitae arcu sollicitudin pretium sed quis augue.",
    _Map: "40.748440°, -73.984559°",
    Status: "INACTIVE",
    _Featured: "No",
  },
  {
    "S/N": 634,
    Image: "https://loremflickr.com/g/320/240/cover",
    Title: "Lorem ipsum",
    _About: "Suspendisse potenti. Donec mi magna, efficitur eu nibh sit amet",
    "Date (Start/End)": "2/5/2020 - 6/2/2023",
    "Time (Start/End)": "5:00 PM - 12:00 AM",
    _Location: "Donec ultricies vitae metus quis convallis.",
    _Address: "In ac metus vitae arcu sollicitudin pretium sed quis augue.",
    _Map: "40.748440°, -73.984559°",
    Status: "ACTIVE",
    _Featured: "Yes",
  },
  {
    "S/N": 637,
    Image: "https://loremflickr.com/g/320/240/cover",
    Title: "Lorem ipsum",
    _About: "Suspendisse potenti. Donec mi magna, efficitur eu nibh sit amet",
    "Date (Start/End)": "2/5/2020 - 6/2/2023",
    "Time (Start/End)": "5:00 PM - 12:00 AM",
    _Location: "Donec ultricies vitae metus quis convallis.",
    _Address: "In ac metus vitae arcu sollicitudin pretium sed quis augue.",
    _Map: "40.748440°, -73.984559°",
    Status: "ACTIVE",
    _Featured: "No",
  },
  {
    "S/N": 374,
    Image: "https://loremflickr.com/g/320/240/cover",
    Title: "Lorem ipsum",
    _About: "Suspendisse potenti. Donec mi magna, efficitur eu nibh sit amet",
    "Date (Start/End)": "2/5/2020 - 6/2/2023",
    "Time (Start/End)": "5:00 PM - 12:00 AM",
    _Location: "Donec ultricies vitae metus quis convallis.",
    _Address: "In ac metus vitae arcu sollicitudin pretium sed quis augue.",
    _Map: "40.748440°, -73.984559°",
    Status: "ACTIVE",
    _Featured: "Yes",
  },
];

// Feedbacks
export const feedbacks = [
  {
    "_S/N": 6374,
    ID: 6374,
    Device: "Android",
    Name: "Pretium Sed",
    _Timestamp: "59:30",
    Image: "https://loremflickr.com/g/320/240/cover",
    _Description:
      "Suspendisse potenti. Donec mi magna, efficitur eu nibh sit amet",
    Status: "RESOLVED",
  },
  {
    "_S/N": 674,
    ID: 674,
    Device: "IOS",
    Name: "Pretium Sed",
    _Timestamp: "59:30",
    Image: "https://loremflickr.com/g/320/240/cover",
    _Description:
      "Suspendisse potenti. Donec mi magna, efficitur eu nibh sit amet",
    Status: "PENDING",
  },
  {
    "_S/N": 634,
    ID: 634,
    Device: "Android",
    Name: "Pretium Sed",
    _Timestamp: "59:30",
    Image: "https://loremflickr.com/g/320/240/cover",
    _Description:
      "Suspendisse potenti. Donec mi magna, efficitur eu nibh sit amet",
    Status: "RESOLVED",
  },
  {
    "_S/N": 637,
    ID: 637,
    Device: "Android",
    Name: "Lorem jack",
    _Timestamp: "59:30",
    Image: "https://loremflickr.com/g/320/240/cover",
    _Description: "sdfgisu dtfisu ytfiusy tfuiysdt uysdt uysdt.",
    Status: "RESOLVED",
  },
  {
    "_S/N": 374,
    ID: 374,
    Device: "IOS",
    Name: "Pretium Sed",
    _Timestamp: "59:30",
    Image: "https://loremflickr.com/g/320/240/cover",
    _Description:
      "Suspendisse potenti. Donec mi magna, efficitur eu nibh sit amet",
    Status: "PENDING",
  },
];

// Contacts
export const contacts = [
  {
    "_S/N": 6374,
    ID: 6374,
    Device: "Android",
    Name: "sodales semper sapien",
    Email: "example@gmail.com",
    _Phone: "+92 465 6874 146",
    _Timestamp: "59:30",
    Status: "RESOLVED",
    Subject: "sodales semper sapien",
    _Message: "Donec ultricies vitae metus quis convallis.",
    _Response: "Not replied yet!",
    _Featured: "Yes",
  },
  {
    "_S/N": 674,
    ID: 674,
    Device: "IOS",
    Name: "sodales semper sapien",
    Email: "example@gmail.com",
    _Phone: "+92 465 6874 146",
    _Timestamp: "59:30",
    Status: "PENDING",
    Subject: "sodales semper sapien",
    _Message: "Donec ultricies vitae metus quis convallis.",
    _Response: "Thanks for contacting us!",
    _Featured: "No",
  },
  {
    "_S/N": 634,
    ID: 634,
    Device: "Android",
    Name: "sodales semper sapien",
    Email: "example@gmail.com",
    _Phone: "+92 465 6874 146",
    _Timestamp: "59:30",
    Status: "RESOLVED",
    Subject: "sodales semper sapien",
    _Message: "Donec ultricies vitae metus quis convallis.",
    _Response: "Thanks for contacting us!",
    _Featured: "Yes",
  },
  {
    "_S/N": 637,
    ID: 637,
    Device: "Android",
    Name: "sodales semper sapien",
    Email: "example@gmail.com",
    _Phone: "+92 465 6874 146",
    _Timestamp: "59:30",
    Status: "RESOLVED",
    Subject: "sodales semper sapien",
    _Message: "Donec ultricies vitae metus quis convallis.",
    _Response: "Not replied yet!",
    _Featured: "No",
  },
  {
    "_S/N": 374,
    ID: 374,
    Device: "IOS",
    Name: "sodales semper sapien",
    Email: "example@gmail.com",
    _Phone: "+92 465 6874 146",
    _Timestamp: "59:30",
    Status: "PENDING",
    Subject: "sodales semper sapien",
    _Message: "Donec ultricies vitae metus quis convallis.",
    _Response: "Thanks for contacting us!",
    _Featured: "Yes",
  },
];

// FAQs
export const faqs = [
  {
    "S/N": 0,
    question: "Donec ultricies vitae metus quis convallis?",
    answer: "Suspendisse potenti. Donec mi magna, efficitur eu nibh sit amet.",
    language: "Latin",
  },
  {
    "S/N": 1,
    question: "Donec ultricies vitae metus quis convallis?",
    answer: "Suspendisse potenti. Donec mi magna, efficitur eu nibh sit amet.",
    language: "Latin",
  },
  {
    "S/N": 2,
    question: "Donec ultricies vitae metus quis convallis?",
    answer: "Suspendisse potenti. Donec mi magna, efficitur eu nibh sit amet.",
    language: "Latin",
  },
  {
    "S/N": 3,
    question: "Donec ultricies vitae metus quis convallis?",
    answer: "Suspendisse potenti. Donec mi magna, efficitur eu nibh sit amet.",
    language: "Latin",
  },
  {
    "S/N": 4,
    question: "Donec ultricies vitae metus quis convallis?",
    answer: "Suspendisse potenti. Donec mi magna, efficitur eu nibh sit amet.",
    language: "Latin",
  },

  {
    "S/N": 5,
    question: "Donec ultricies vitae metus quis convallis?",
    answer: "Suspendisse potenti. Donec mi magna, efficitur eu nibh sit amet.",
    language: "English",
  },
  {
    "S/N": 6,
    question: "Donec ultricies vitae metus quis convallis?",
    answer: "Suspendisse potenti. Donec mi magna, efficitur eu nibh sit amet.",
    language: "English",
  },
  {
    "S/N": 7,
    question: "Donec ultricies vitae metus quis convallis?",
    answer: "Suspendisse potenti. Donec mi magna, efficitur eu nibh sit amet.",
    language: "English",
  },
  {
    "S/N": 8,
    question: "Donec ultricies vitae metus quis convallis?",
    answer: "Suspendisse potenti. Donec mi magna, efficitur eu nibh sit amet.",
    language: "English",
  },
  {
    "S/N": 9,
    question: "Donec ultricies vitae metus quis convallis?",
    answer: "Suspendisse potenti. Donec mi magna, efficitur eu nibh sit amet.",
    language: "English",
  },

  {
    "S/N": 10,
    question: "Donec ultricies vitae metus quis convallis?",
    answer: "Suspendisse potenti. Donec mi magna, efficitur eu nibh sit amet.",
    language: "Afrikaans",
  },
  {
    "S/N": 11,
    question: "Donec ultricies vitae metus quis convallis?",
    answer: "Suspendisse potenti. Donec mi magna, efficitur eu nibh sit amet.",
    language: "Afrikaans",
  },
  {
    "S/N": 12,
    question: "Jack",
    answer: "Donec ultricies vitae metus quis convallis.",
    language: "Afrikaans",
  },
  {
    "S/N": 13,
    question: "Donec ultricies vitae metus quis convallis?",
    answer: "Suspendisse potenti. Donec mi magna, efficitur eu nibh sit amet.",
    language: "Afrikaans",
  },
  {
    "S/N": 14,
    question: "Donec ultricies vitae metus quis convallis?",
    answer: "Suspendisse potenti. Donec mi magna, efficitur eu nibh sit amet.",
    language: "Afrikaans",
  },
  {
    "S/N": 15,
    question: "Donec ultricies vitae metus quis convallis?",
    answer:
      "Suspendisse potenti. Donec mi magna, efficitur eu nibh sit amet. dsa.",
    language: "Spanish",
  },
  {
    "S/N": 16,
    question: "Donec ultricies vitae metus quis convallis?",
    answer:
      "Suspendisse potenti. Donec mi magna, efficitur eu nibh sit amet. dsa.",
    language: "Spanish",
  },
  {
    "S/N": 17,
    question: "John",
    answer: "kayfi  aisd iut dasit dsa.",
    language: "Spanish",
  },
  {
    "S/N": 18,
    question: "Donec ultricies vitae metus quis convallis?",
    answer:
      "Suspendisse potenti. Donec mi magna, efficitur eu nibh sit amet. dsa.",
    language: "Spanish",
  },
  {
    "S/N": 19,
    question: "Donec ultricies vitae metus quis convallis?",
    answer:
      "Suspendisse potenti. Donec mi magna, efficitur eu nibh sit amet. dsa.",
    language: "Spanish",
  },
];

// Roles
export const rolesData = [
  {
    "S/N": 0,
    Role: "Editor",
    Privileges: ["Dashboard", "Users Management", "Alerts"],
  },
  {
    "S/N": 1,
    Role: "Editor",
    Privileges: ["Dashboard", "Users Management", "Alerts"],
  },
  {
    "S/N": 2,
    Role: "Moderator",
    Privileges: ["Dashboard", "Users Management", "Alerts"],
  },
  {
    "S/N": 3,
    Role: "Admin",
    Privileges: ["Dashboard", "Users Management", "Alerts"],
  },
];

export const privilegesStructure = {
  Dashboard: false,
  Access: {
    Roles: {
      View: false,
      Create: false,
      Edit: false,
      Delete: false,
    },
    "Sub-Admin": {
      View: false,
      Create: false,
      Edit: false,
      Delete: false,
    },
  },
  Notification: {
    View: false,
    Delete: false,
  },
  "Users Management": {
    View: false,
    Edit: false,
    Delete: false,
  },
  "Promotion Management": {
    Banner: {
      View: false,
      Create: false,
      Edit: false,
      Delete: false,
    },
    "Pop-up": {
      View: false,
      Create: false,
      Edit: false,
      Delete: false,
    },
  },
  "Books Management": {
    View: false,
    Edit: false,
    Delete: false,
  },
  "Publish Book": {
    View: false,
    Edit: false,
  },
  "Parish Management": {
    View: false,
    Create: false,
    Edit: false,
    Delete: false,
  },
  "Events Management": {
    View: false,
    Create: false,
    Edit: false,
    Delete: false,
  },
  "Feedback Management": {
    View: false,
    Delete: false,
  },
  "Contact Management": {
    View: false,
    Delete: false,
  },
  "Settings Management": {
    "Admin Email": {
      View: false,
      Edit: false,
    },
    "General Countries": {
      View: false,
      Create: false,
      Edit: false,
      Delete: false,
    },
    "Parish Categories": {
      View: false,
      Create: false,
      Edit: false,
      Delete: false,
    },
    "Parish Countries": {
      View: false,
      Create: false,
      Edit: false,
      Delete: false,
    },
    Region: {
      View: false,
      Create: false,
      Edit: false,
      Delete: false,
    },
    Province: {
      View: false,
      Create: false,
      Edit: false,
      Delete: false,
    },
    "Book Category": {
      View: false,
      Create: false,
      Edit: false,
      Delete: false,
    },
    "Book Language": {
      View: false,
      Create: false,
      Edit: false,
      Delete: false,
    },
    "About Kirista": {
      View: false,
      Edit: false,
    },
    "About RCCG": {
      View: false,
      Edit: false,
    },
    "About RCCG Structure": {
      View: false,
      Edit: false,
    },
    "About RCCG Continent 2": {
      View: false,
      Edit: false,
    },
    Terms: {
      View: false,
      Edit: false,
    },
    Privacy: {
      View: false,
      Edit: false,
    },
    FAQ: {
      View: false,
      Create: false,
      Edit: false,
      Delete: false,
    },
  },
};

export const adminPrivileges = {
  Dashboard: true,
  Access: {
    Roles: {
      View: true,
      Create: true,
      Edit: true,
      Delete: true,
    },
    "Sub-Admin": {
      View: true,
      Create: true,
      Edit: true,
      Delete: true,
    },
  },
  "Users Management": {
    View: true,
    Edit: true,
    Delete: true,
  },
  "Promotion Management": {
    Banner: {
      View: true,
      Create: true,
      Edit: true,
      Delete: true,
    },
    "Pop-up": {
      View: true,
      Create: true,
      Edit: true,
      Delete: true,
    },
    Notification: true,
  },
  "Books Management": {
    View: true,
    Edit: true,
    Delete: true,
  },
  "Publish Book": {
    View: true,
    Edit: true,
  },
  "Parish Management": {
    View: true,
    Create: true,
    Edit: true,
    Delete: true,
  },
  "Events Management": {
    View: true,
    Create: true,
    Edit: true,
    Delete: true,
  },
  "Feedback Management": {
    View: true,
    Delete: true,
  },
  "Contact Management": {
    View: true,
    Delete: true,
  },
  "Settings Management": {
    "Admin Email": {
      View: true,
      Edit: true,
    },
    "General Countries": {
      View: true,
      Create: true,
      Edit: true,
      Delete: true,
    },
    "Parish Categories": {
      View: true,
      Create: true,
      Edit: true,
      Delete: true,
    },
    "Parish Countries": {
      View: true,
      Create: true,
      Edit: true,
      Delete: true,
    },
    Region: {
      View: true,
      Create: true,
      Edit: true,
      Delete: true,
    },
    Province: {
      View: true,
      Create: true,
      Edit: true,
      Delete: true,
    },
    "Book Category": {
      View: true,
      Create: true,
      Edit: true,
      Delete: true,
    },
    "Book Language": {
      View: true,
      Create: true,
      Edit: true,
      Delete: true,
    },
    "About Kirista": {
      View: true,
      Edit: true,
    },
    "About RCCG": {
      View: true,
      Edit: true,
    },
    "About RCCG Structure": {
      View: true,
      Edit: true,
    },
    "About RCCG Continent 2": {
      View: true,
      Edit: true,
    },
    Terms: {
      View: true,
      Edit: true,
    },
    Privacy: {
      View: true,
      Edit: true,
    },
    FAQ: {
      View: true,
      Create: true,
      Edit: true,
      Delete: true,
    },
  },
};

export const roles = ["Admin", "Editor", "Moderator"];

// Sub-Admins
export const subadmins = [
  {
    "S/N": 0,
    Name: "Lorem ipsum",
    Email: "example@gmail.com",
    Password: "admin63586",
    "Phone Number": "+92 678 6879 468",
    Role: "Admin",
  },
  {
    "S/N": 1,
    Name: "Lorem ipsum",
    Email: "example@gmail.com",
    Password: "admin63586",
    "Phone Number": "+92 678 6879 468",
    Role: "Editor",
  },
  {
    "S/N": 2,
    Name: "Lorem ipsum",
    Email: "example@gmail.com",
    Password: "admin63586",
    "Phone Number": "+92 678 6879 468",
    Role: "Admin",
  },
  {
    "S/N": 3,
    Name: "Lorem ipsum",
    Email: "example@gmail.com",
    Password: "admin63586",
    "Phone Number": "+92 678 6879 468",
    Role: "Admin",
  },
  {
    "S/N": 4,
    Name: "Lorem ipsum",
    Email: "example@gmail.com",
    Password: "admin63586",
    "Phone Number": "+92 678 6879 468",
    Role: "Editor",
  },
];

// Privacy Policy
export const privacyPolicy = {
  English:
    "The customer is very important, the customer will be followed by the customer. There should be no cars, no cars, no dirty beds, no dirty dishes. As an employee, he does not accept hatred or desire. It was a weekend. Even if the venomous Lacinia is great, let it be a lot of rhoncus arcu egestus ullamcorper. Each vehicle is not for sale. The price of the product is different. But the sad trigger and the great expectation, adorning the life of the real estate. No production and no sauce. Vivamus flatters the laughter of the male, it needs the vulputate before the investment of the cartoon. Everyone has to put the players. Until and even before the soft keyboard. Even that limits the pain, and it becomes a joke. Everyone and no one wants. There is no laughter in the valley. It is necessary to invest in the real estate, but the lacinia needs to be said. As the grief of the eros, but the ultricies itself, but the vehicles of the diam of the chocolate. \n\n Mauris needs an urn in hatred of tincidunt ultricies a sed dui. He takes care of himself but wants to invest in his homework. Sometimes the yeast is put on. Each one is targeted by a mass. It is convenient for pregnant women. Tomorrow, what will be the problem of pain, he said. He is said to have lived in this street. Morrow and mourning wise. There is no clinical interest, or sometimes from time to time. There is no poison, and no poison trigger. Each of them was a developer, layer by layer, and what kind of product was it. Children's playground, football as a football field, pregnant before that. Mauris ex tortor, saucement et eleifend et, euismod not before. Intrepid lorem nibh, the target and the target should be a lot, different in the elit. \n\n Duis malesuada dui quis lorem sad aliquam It's a soft salad, but neither is a bed of protein. Laughter in football. Until there is great publicity, the homework should be more important than the basketball sauce. Donec massa massa, pharetra in ague a, imperdiet laoreet mauris. For the sauce, the pain is not aimed at the ends, just the ugly bow of the tincidunt, it is important for the promotion and education. But the gate, the ligula of the Euismod hendrerit, was just a mass of property, and the makeup of life was not lent to the players. For the kids, I'm going to have a salad at the same time. No employee like Lacinia, football player, flatters the free. \n \n Tomorrow hendrerit fermentum nibh sed faucibus There is nothing easy. It's hate before, but the time is over, always Euismod now. In sed nisl a felis faucibus laoreet. There is no need to be pure in any sad moment or result. Everyone was the author, but the real estate, pure grief. Every one of my lions, be it soft or varied, takes care of itself. Until cartoon real estate developers. Everyone and Leo should be happy unless they are very busy.",
  Latin:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam sit amet nulla aliquet, varius lectus venenatis, dapibus turpis. Ut molestie odio nec egestas suscipit. Aliquam erat volutpat. Etiam venenatis lacinia magna, sit amet rhoncus arcu egestas ullamcorper. Quisque vehicula luctus enim non scelerisque. Proin auctor pretium nisi ac varius. Sed tristique felis ac magna malesuada, vitae ornare augue mattis. Vestibulum ac condimentum nulla. Vivamus blandit malesuada risus, eget vulputate ante imperdiet viverra. Quisque ut posuere nisl. Donec ac enim nec ante mollis tincidunt. Etiam id finibus dolor, et efficitur mauris. Quisque nec nulla velit. Nullam sagittis risus quis congue convallis. Fusce placerat rutrum ipsum, eget lacinia velit dictum sed. Ut luctus eros sed ipsum ultricies, sed vehicula diam scelerisque. \n\n Mauris eget urna in odio tincidunt ultricies a sed dui. Suspendisse suscipit sed velit placerat congue. Mauris fermentum posuere interdum. Quisque vel iaculis massa. In faucibus gravida commodo. Cras consequat dolor quis dolor hendrerit, dictum varius nunc tincidunt. In hac habitasse platea dictumst. Cras ac luctus sapien. Nulla aliquet orci velit, vel interdum ex tempus at. Praesent ac venenatis nulla, nec venenatis felis. Quisque elit erat, accumsan at accumsan et, pellentesque vestibulum quam. Pellentesque ipsum diam, lobortis ut vestibulum eu, gravida id ante. Mauris ex tortor, condimentum et eleifend et, euismod non ante. Integer lorem nibh, iaculis ac iaculis sit amet, varius in elit. \n\n Duis malesuada dui quis lorem tristique aliquam. Suspendisse mollis sem est, sed dapibus lectus ultricies nec. In eu fringilla risus. Donec magna augue, congue sit amet quam at, ultrices condimentum eros. Donec massa massa, pharetra in augue a, imperdiet laoreet mauris. Nam condimentum, dolor non iaculis finibus, turpis arcu tincidunt justo, sit amet fringilla enim augue ac lectus. Sed porta, ligula a euismod hendrerit, lectus massa mattis justo, vitae rutrum neque lectus in nisl. Proin pellentesque tincidunt sem in tempor. Nullam molestie quam lacinia, dignissim elit eu, blandit libero. \n \n Cras hendrerit fermentum nibh sed faucibus. Nulla facilisi. Praesent odio ante, lobortis sed lectus tempus, semper euismod nunc. In sed nisl a felis faucibus laoreet. Nulla sit amet purus in nulla tristique interdum vel consequat eros. Quisque a erat auctor, mattis orci sed, luctus purus. Quisque leo mi, mollis vel varius sit amet, suscipit non eros. Donec viverra mattis tincidunt. Quisque et leo sit amet nisi ultricies mattis.",
  Afrikaans:
    "Die kliënt is baie belangrik, die kliënt sal deur die kliënt gevolg word. Daar moet geen motors, geen motors, geen vuil beddens, geen vuil skottelgoed wees nie. As werknemer aanvaar hy nie haat of begeerte nie. Dit was 'n naweek. Selfs as die giftige Lacinia groot is, laat dit baie rhoncus arcu egestus ullamcorper wees. Elke voertuig is nie te koop nie. Die prys van die produk is anders. Maar die hartseer sneller en die groot verwagting, versier die lewe van die eiendom. Geen produksie en geen sous nie. Vivamus vlei die lag van die mannetjie, dit het die vulputaat nodig voor die belegging van die spotprent. Almal moet die spelers sit. Tot en selfs voor die sagte sleutelbord. Selfs dit beperk die pyn, en dit word 'n grap. Almal en niemand wil nie. Daar word nie gelag in die vallei nie. Dit is nodig om in die eiendom te belê, maar die lacinia moet gesê word. Soos die hartseer van die eros, maar die ultricies self, maar die voertuie van die diam van die sjokolade. \n\n Mauris het 'n urn nodig in haat van tincidunt ultricities a sed dui. Hy sorg vir homself maar wil in sy huiswerk belê. Soms word die gis opgesit. Elkeen word deur 'n massa geteiken. Dit is gerieflik vir swanger vroue. Môre, wat sal die probleem van pyn wees, het hy gesê. Daar word gesê dat hy in hierdie straat gewoon het. Môre en rou wys. Daar is geen kliniese belangstelling nie, of soms van tyd tot tyd. Daar is geen gif nie, en geen gifsneller nie. Elkeen van hulle was 'n ontwikkelaar, laag vir laag, en watter soort produk was dit. Kinderspeelgrond, sokker as 'n sokkerveld, voor dit swanger. Mauris ex tortor, saucement et eleifend et, euismod nie voor nie. Onverskrokke lorem nibh, die teiken en die teiken moet baie anders wees in die veld. \n\n Duis malesuada dui quis lorem sad aliquam Dit is 'n sagte slaai, maar ook nie 'n proteïenbed nie. Gelag in sokker. Totdat daar groot publisiteit is, behoort die huiswerk belangriker te wees as die basketbalsous. Donec massa massa, pharetra in ague a, imperdiet laoreet mauris. Vir die sous is die pyn nie op die punte gerig nie, net die lelike boog van die tincidunt, dit is belangrik vir die bevordering en opvoeding. Maar die hek, die ligula van die Euismod-hendrerit, was net 'n massa eiendom, en die samestelling van die lewe is nie aan die spelers geleen nie. Vir die kinders gaan ek terselfdertyd 'n slaai eet. Geen werknemer soos Lacinia, sokkerspeler, vlei die vryes nie. \n \n Môre hendrerit fermentum nibh sed faucibus Daar is niks maklik nie. Dis haat voorheen, maar die tyd is verby, altyd Euismod nou. In sed nisl 'n felis faucibus laoreet. Dit is nie nodig om rein te wees in enige hartseer oomblik of resultaat nie. Almal was die skrywer, maar die eiendom, pure hartseer. Elkeen van my leeus, of dit nou sag of gevarieerd is, sorg vir homself. Tot spotprent eiendomsontwikkelaars. Almal en Leo behoort gelukkig te wees tensy hulle baie besig is.",
  Spanish:
    "El cliente es muy importante, el cliente será seguido por el cliente. No debe haber coches, ni coches, ni camas sucias, ni platos sucios. Como empleado, no acepta el odio ni el deseo. fue un fin de semana Incluso si la venenosa Lacinia es genial, que sea mucho rhoncus arcu egestus ullamcorper. Cada vehículo no está a la venta. El precio del producto es diferente. Pero el triste detonante y la gran expectación, adornan la vida de la inmobiliaria. Sin producción y sin salsa. Vivamus halaga la risa del varón, necesita la vulputación antes de la inversión de la caricatura. Todo el mundo tiene que poner los jugadores. Hasta e incluso antes del teclado virtual. Incluso eso limita el dolor y se convierte en una broma. Todos y nadie quiere. No hay risa en el valle. Hay que invertir en los inmuebles, pero hay que decir la lacinia. Como el dolor del eros, pero los ultricios mismos, pero los vehículos del diam del chocolate. \n\n Mauris necesita una urna por odio a las tincidunt ultricies a sed dui. Se cuida pero quiere invertir en su tarea. A veces se pone la levadura. Cada uno es el objetivo de una masa. Es conveniente para las mujeres embarazadas. Mañana, cuál será el problema del dolor, dijo. Se dice que vivió en esta calle. Mañana y luto sabio. No hay interés clínico, oa veces de vez en cuando. No hay veneno, ni disparador de veneno. Cada uno de ellos era un revelador, capa por capa, y qué tipo de producto era. Parque infantil, fútbol como campo de fútbol, ​​embarazada antes de eso. Mauris ex tortor, saucement et eleifend et, euismod no antes. Intrépido lorem nibh, el objetivo y el objetivo deben ser mucho, diferentes en el campo. \n\n Duis malesuada dui quis lorem sad aliquam Es una ensalada blanda, pero tampoco es un lecho de proteínas. La risa en el fútbol. Hasta que haya una gran publicidad, la tarea debería ser más importante que la salsa del baloncesto. Donec massa massa, pharetra in ague a, imperdiet laoreet mauris. Para la salsa, el dolor no va dirigido a las puntas, solo el feo lazo del tincidunt, es importante para la promoción y educación. Pero la puerta, la ligula del Euismod hendrerit, no era más que una masa de propiedad, y la composición de la vida no se prestaba a los jugadores. Para los niños, voy a tener una ensalada al mismo tiempo. Ningún empleado como Lacinia, futbolista, halaga la libertad. \n \n Mañana hendrerit fermentum nibh sed faucibus No hay nada fácil. Es odio antes, pero el tiempo se acabó, siempre Euismod ahora. In sed nisl a felis faucibus laoreet. No hay necesidad de ser puro en ningún momento o resultado triste. Todo el mundo era autor, menos la inmobiliaria, pura pena. Cada uno de mis leones, ya sea suave o variado, se cuida solo. Hasta los desarrolladores de bienes raíces de dibujos animados. Todos y Leo deberían estar felices a menos que estén muy ocupados.",
};

// Terms
export const terms = {
  English:
    "The customer is very important, the customer will be followed by the customer. There should be no cars, no cars, no dirty beds, no dirty dishes. As an employee, he does not accept hatred or desire. It was a weekend. Even if the venomous Lacinia is great, let it be a lot of rhoncus arcu egestus ullamcorper. Each vehicle is not for sale. The price of the product is different. But the sad trigger and the great expectation, adorning the life of the real estate. No production and no sauce. Vivamus flatters the laughter of the male, it needs the vulputate before the investment of the cartoon. Everyone has to put the players. Until and even before the soft keyboard. Even that limits the pain, and it becomes a joke. Everyone and no one wants. There is no laughter in the valley. It is necessary to invest in the real estate, but the lacinia needs to be said. As the grief of the eros, but the ultricies itself, but the vehicles of the diam of the chocolate. \n\n Mauris needs an urn in hatred of tincidunt ultricies a sed dui. He takes care of himself but wants to invest in his homework. Sometimes the yeast is put on. Each one is targeted by a mass. It is convenient for pregnant women. Tomorrow, what will be the problem of pain, he said. He is said to have lived in this street. Morrow and mourning wise. There is no clinical interest, or sometimes from time to time. There is no poison, and no poison trigger. Each of them was a developer, layer by layer, and what kind of product was it. Children's playground, football as a football field, pregnant before that. Mauris ex tortor, saucement et eleifend et, euismod not before. Intrepid lorem nibh, the target and the target should be a lot, different in the elit. \n\n Duis malesuada dui quis lorem sad aliquam It's a soft salad, but neither is a bed of protein. Laughter in football. Until there is great publicity, the homework should be more important than the basketball sauce. Donec massa massa, pharetra in ague a, imperdiet laoreet mauris. For the sauce, the pain is not aimed at the ends, just the ugly bow of the tincidunt, it is important for the promotion and education. But the gate, the ligula of the Euismod hendrerit, was just a mass of property, and the makeup of life was not lent to the players. For the kids, I'm going to have a salad at the same time. No employee like Lacinia, football player, flatters the free. \n \n Tomorrow hendrerit fermentum nibh sed faucibus There is nothing easy. It's hate before, but the time is over, always Euismod now. In sed nisl a felis faucibus laoreet. There is no need to be pure in any sad moment or result. Everyone was the author, but the real estate, pure grief. Every one of my lions, be it soft or varied, takes care of itself. Until cartoon real estate developers. Everyone and Leo should be happy unless they are very busy.",
  Latin:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam sit amet nulla aliquet, varius lectus venenatis, dapibus turpis. Ut molestie odio nec egestas suscipit. Aliquam erat volutpat. Etiam venenatis lacinia magna, sit amet rhoncus arcu egestas ullamcorper. Quisque vehicula luctus enim non scelerisque. Proin auctor pretium nisi ac varius. Sed tristique felis ac magna malesuada, vitae ornare augue mattis. Vestibulum ac condimentum nulla. Vivamus blandit malesuada risus, eget vulputate ante imperdiet viverra. Quisque ut posuere nisl. Donec ac enim nec ante mollis tincidunt. Etiam id finibus dolor, et efficitur mauris. Quisque nec nulla velit. Nullam sagittis risus quis congue convallis. Fusce placerat rutrum ipsum, eget lacinia velit dictum sed. Ut luctus eros sed ipsum ultricies, sed vehicula diam scelerisque. \n\n Mauris eget urna in odio tincidunt ultricies a sed dui. Suspendisse suscipit sed velit placerat congue. Mauris fermentum posuere interdum. Quisque vel iaculis massa. In faucibus gravida commodo. Cras consequat dolor quis dolor hendrerit, dictum varius nunc tincidunt. In hac habitasse platea dictumst. Cras ac luctus sapien. Nulla aliquet orci velit, vel interdum ex tempus at. Praesent ac venenatis nulla, nec venenatis felis. Quisque elit erat, accumsan at accumsan et, pellentesque vestibulum quam. Pellentesque ipsum diam, lobortis ut vestibulum eu, gravida id ante. Mauris ex tortor, condimentum et eleifend et, euismod non ante. Integer lorem nibh, iaculis ac iaculis sit amet, varius in elit. \n\n Duis malesuada dui quis lorem tristique aliquam. Suspendisse mollis sem est, sed dapibus lectus ultricies nec. In eu fringilla risus. Donec magna augue, congue sit amet quam at, ultrices condimentum eros. Donec massa massa, pharetra in augue a, imperdiet laoreet mauris. Nam condimentum, dolor non iaculis finibus, turpis arcu tincidunt justo, sit amet fringilla enim augue ac lectus. Sed porta, ligula a euismod hendrerit, lectus massa mattis justo, vitae rutrum neque lectus in nisl. Proin pellentesque tincidunt sem in tempor. Nullam molestie quam lacinia, dignissim elit eu, blandit libero. \n \n Cras hendrerit fermentum nibh sed faucibus. Nulla facilisi. Praesent odio ante, lobortis sed lectus tempus, semper euismod nunc. In sed nisl a felis faucibus laoreet. Nulla sit amet purus in nulla tristique interdum vel consequat eros. Quisque a erat auctor, mattis orci sed, luctus purus. Quisque leo mi, mollis vel varius sit amet, suscipit non eros. Donec viverra mattis tincidunt. Quisque et leo sit amet nisi ultricies mattis.",
  Afrikaans:
    "Die kliënt is baie belangrik, die kliënt sal deur die kliënt gevolg word. Daar moet geen motors, geen motors, geen vuil beddens, geen vuil skottelgoed wees nie. As werknemer aanvaar hy nie haat of begeerte nie. Dit was 'n naweek. Selfs as die giftige Lacinia groot is, laat dit baie rhoncus arcu egestus ullamcorper wees. Elke voertuig is nie te koop nie. Die prys van die produk is anders. Maar die hartseer sneller en die groot verwagting, versier die lewe van die eiendom. Geen produksie en geen sous nie. Vivamus vlei die lag van die mannetjie, dit het die vulputaat nodig voor die belegging van die spotprent. Almal moet die spelers sit. Tot en selfs voor die sagte sleutelbord. Selfs dit beperk die pyn, en dit word 'n grap. Almal en niemand wil nie. Daar word nie gelag in die vallei nie. Dit is nodig om in die eiendom te belê, maar die lacinia moet gesê word. Soos die hartseer van die eros, maar die ultricies self, maar die voertuie van die diam van die sjokolade. \n\n Mauris het 'n urn nodig in haat van tincidunt ultricities a sed dui. Hy sorg vir homself maar wil in sy huiswerk belê. Soms word die gis opgesit. Elkeen word deur 'n massa geteiken. Dit is gerieflik vir swanger vroue. Môre, wat sal die probleem van pyn wees, het hy gesê. Daar word gesê dat hy in hierdie straat gewoon het. Môre en rou wys. Daar is geen kliniese belangstelling nie, of soms van tyd tot tyd. Daar is geen gif nie, en geen gifsneller nie. Elkeen van hulle was 'n ontwikkelaar, laag vir laag, en watter soort produk was dit. Kinderspeelgrond, sokker as 'n sokkerveld, voor dit swanger. Mauris ex tortor, saucement et eleifend et, euismod nie voor nie. Onverskrokke lorem nibh, die teiken en die teiken moet baie anders wees in die veld. \n\n Duis malesuada dui quis lorem sad aliquam Dit is 'n sagte slaai, maar ook nie 'n proteïenbed nie. Gelag in sokker. Totdat daar groot publisiteit is, behoort die huiswerk belangriker te wees as die basketbalsous. Donec massa massa, pharetra in ague a, imperdiet laoreet mauris. Vir die sous is die pyn nie op die punte gerig nie, net die lelike boog van die tincidunt, dit is belangrik vir die bevordering en opvoeding. Maar die hek, die ligula van die Euismod-hendrerit, was net 'n massa eiendom, en die samestelling van die lewe is nie aan die spelers geleen nie. Vir die kinders gaan ek terselfdertyd 'n slaai eet. Geen werknemer soos Lacinia, sokkerspeler, vlei die vryes nie. \n \n Môre hendrerit fermentum nibh sed faucibus Daar is niks maklik nie. Dis haat voorheen, maar die tyd is verby, altyd Euismod nou. In sed nisl 'n felis faucibus laoreet. Dit is nie nodig om rein te wees in enige hartseer oomblik of resultaat nie. Almal was die skrywer, maar die eiendom, pure hartseer. Elkeen van my leeus, of dit nou sag of gevarieerd is, sorg vir homself. Tot spotprent eiendomsontwikkelaars. Almal en Leo behoort gelukkig te wees tensy hulle baie besig is.",
  Spanish:
    "El cliente es muy importante, el cliente será seguido por el cliente. No debe haber coches, ni coches, ni camas sucias, ni platos sucios. Como empleado, no acepta el odio ni el deseo. fue un fin de semana Incluso si la venenosa Lacinia es genial, que sea mucho rhoncus arcu egestus ullamcorper. Cada vehículo no está a la venta. El precio del producto es diferente. Pero el triste detonante y la gran expectación, adornan la vida de la inmobiliaria. Sin producción y sin salsa. Vivamus halaga la risa del varón, necesita la vulputación antes de la inversión de la caricatura. Todo el mundo tiene que poner los jugadores. Hasta e incluso antes del teclado virtual. Incluso eso limita el dolor y se convierte en una broma. Todos y nadie quiere. No hay risa en el valle. Hay que invertir en los inmuebles, pero hay que decir la lacinia. Como el dolor del eros, pero los ultricios mismos, pero los vehículos del diam del chocolate. \n\n Mauris necesita una urna por odio a las tincidunt ultricies a sed dui. Se cuida pero quiere invertir en su tarea. A veces se pone la levadura. Cada uno es el objetivo de una masa. Es conveniente para las mujeres embarazadas. Mañana, cuál será el problema del dolor, dijo. Se dice que vivió en esta calle. Mañana y luto sabio. No hay interés clínico, oa veces de vez en cuando. No hay veneno, ni disparador de veneno. Cada uno de ellos era un revelador, capa por capa, y qué tipo de producto era. Parque infantil, fútbol como campo de fútbol, ​​embarazada antes de eso. Mauris ex tortor, saucement et eleifend et, euismod no antes. Intrépido lorem nibh, el objetivo y el objetivo deben ser mucho, diferentes en el campo. \n\n Duis malesuada dui quis lorem sad aliquam Es una ensalada blanda, pero tampoco es un lecho de proteínas. La risa en el fútbol. Hasta que haya una gran publicidad, la tarea debería ser más importante que la salsa del baloncesto. Donec massa massa, pharetra in ague a, imperdiet laoreet mauris. Para la salsa, el dolor no va dirigido a las puntas, solo el feo lazo del tincidunt, es importante para la promoción y educación. Pero la puerta, la ligula del Euismod hendrerit, no era más que una masa de propiedad, y la composición de la vida no se prestaba a los jugadores. Para los niños, voy a tener una ensalada al mismo tiempo. Ningún empleado como Lacinia, futbolista, halaga la libertad. \n \n Mañana hendrerit fermentum nibh sed faucibus No hay nada fácil. Es odio antes, pero el tiempo se acabó, siempre Euismod ahora. In sed nisl a felis faucibus laoreet. No hay necesidad de ser puro en ningún momento o resultado triste. Todo el mundo era autor, menos la inmobiliaria, pura pena. Cada uno de mis leones, ya sea suave o variado, se cuida solo. Hasta los desarrolladores de bienes raíces de dibujos animados. Todos y Leo deberían estar felices a menos que estén muy ocupados.",
};

// About Kirista
export const about = {
  English:
    "The customer is very important, the customer will be followed by the customer. There should be no cars, no cars, no dirty beds, no dirty dishes. As an employee, he does not accept hatred or desire. It was a weekend. Even if the venomous Lacinia is great, let it be a lot of rhoncus arcu egestus ullamcorper. Each vehicle is not for sale. The price of the product is different. But the sad trigger and the great expectation, adorning the life of the real estate. No production and no sauce. Vivamus flatters the laughter of the male, it needs the vulputate before the investment of the cartoon. Everyone has to put the players. Until and even before the soft keyboard. Even that limits the pain, and it becomes a joke. Everyone and no one wants. There is no laughter in the valley. It is necessary to invest in the real estate, but the lacinia needs to be said. As the grief of the eros, but the ultricies itself, but the vehicles of the diam of the chocolate. \n\n Mauris needs an urn in hatred of tincidunt ultricies a sed dui. He takes care of himself but wants to invest in his homework. Sometimes the yeast is put on. Each one is targeted by a mass. It is convenient for pregnant women. Tomorrow, what will be the problem of pain, he said. He is said to have lived in this street. Morrow and mourning wise. There is no clinical interest, or sometimes from time to time. There is no poison, and no poison trigger. Each of them was a developer, layer by layer, and what kind of product was it. Children's playground, football as a football field, pregnant before that. Mauris ex tortor, saucement et eleifend et, euismod not before. Intrepid lorem nibh, the target and the target should be a lot, different in the elit. \n\n Duis malesuada dui quis lorem sad aliquam It's a soft salad, but neither is a bed of protein. Laughter in football. Until there is great publicity, the homework should be more important than the basketball sauce. Donec massa massa, pharetra in ague a, imperdiet laoreet mauris. For the sauce, the pain is not aimed at the ends, just the ugly bow of the tincidunt, it is important for the promotion and education. But the gate, the ligula of the Euismod hendrerit, was just a mass of property, and the makeup of life was not lent to the players. For the kids, I'm going to have a salad at the same time. No employee like Lacinia, football player, flatters the free. \n \n Tomorrow hendrerit fermentum nibh sed faucibus There is nothing easy. It's hate before, but the time is over, always Euismod now. In sed nisl a felis faucibus laoreet. There is no need to be pure in any sad moment or result. Everyone was the author, but the real estate, pure grief. Every one of my lions, be it soft or varied, takes care of itself. Until cartoon real estate developers. Everyone and Leo should be happy unless they are very busy.",
  Latin:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam sit amet nulla aliquet, varius lectus venenatis, dapibus turpis. Ut molestie odio nec egestas suscipit. Aliquam erat volutpat. Etiam venenatis lacinia magna, sit amet rhoncus arcu egestas ullamcorper. Quisque vehicula luctus enim non scelerisque. Proin auctor pretium nisi ac varius. Sed tristique felis ac magna malesuada, vitae ornare augue mattis. Vestibulum ac condimentum nulla. Vivamus blandit malesuada risus, eget vulputate ante imperdiet viverra. Quisque ut posuere nisl. Donec ac enim nec ante mollis tincidunt. Etiam id finibus dolor, et efficitur mauris. Quisque nec nulla velit. Nullam sagittis risus quis congue convallis. Fusce placerat rutrum ipsum, eget lacinia velit dictum sed. Ut luctus eros sed ipsum ultricies, sed vehicula diam scelerisque. \n\n Mauris eget urna in odio tincidunt ultricies a sed dui. Suspendisse suscipit sed velit placerat congue. Mauris fermentum posuere interdum. Quisque vel iaculis massa. In faucibus gravida commodo. Cras consequat dolor quis dolor hendrerit, dictum varius nunc tincidunt. In hac habitasse platea dictumst. Cras ac luctus sapien. Nulla aliquet orci velit, vel interdum ex tempus at. Praesent ac venenatis nulla, nec venenatis felis. Quisque elit erat, accumsan at accumsan et, pellentesque vestibulum quam. Pellentesque ipsum diam, lobortis ut vestibulum eu, gravida id ante. Mauris ex tortor, condimentum et eleifend et, euismod non ante. Integer lorem nibh, iaculis ac iaculis sit amet, varius in elit. \n\n Duis malesuada dui quis lorem tristique aliquam. Suspendisse mollis sem est, sed dapibus lectus ultricies nec. In eu fringilla risus. Donec magna augue, congue sit amet quam at, ultrices condimentum eros. Donec massa massa, pharetra in augue a, imperdiet laoreet mauris. Nam condimentum, dolor non iaculis finibus, turpis arcu tincidunt justo, sit amet fringilla enim augue ac lectus. Sed porta, ligula a euismod hendrerit, lectus massa mattis justo, vitae rutrum neque lectus in nisl. Proin pellentesque tincidunt sem in tempor. Nullam molestie quam lacinia, dignissim elit eu, blandit libero. \n \n Cras hendrerit fermentum nibh sed faucibus. Nulla facilisi. Praesent odio ante, lobortis sed lectus tempus, semper euismod nunc. In sed nisl a felis faucibus laoreet. Nulla sit amet purus in nulla tristique interdum vel consequat eros. Quisque a erat auctor, mattis orci sed, luctus purus. Quisque leo mi, mollis vel varius sit amet, suscipit non eros. Donec viverra mattis tincidunt. Quisque et leo sit amet nisi ultricies mattis.",
  Afrikaans:
    "Die kliënt is baie belangrik, die kliënt sal deur die kliënt gevolg word. Daar moet geen motors, geen motors, geen vuil beddens, geen vuil skottelgoed wees nie. As werknemer aanvaar hy nie haat of begeerte nie. Dit was 'n naweek. Selfs as die giftige Lacinia groot is, laat dit baie rhoncus arcu egestus ullamcorper wees. Elke voertuig is nie te koop nie. Die prys van die produk is anders. Maar die hartseer sneller en die groot verwagting, versier die lewe van die eiendom. Geen produksie en geen sous nie. Vivamus vlei die lag van die mannetjie, dit het die vulputaat nodig voor die belegging van die spotprent. Almal moet die spelers sit. Tot en selfs voor die sagte sleutelbord. Selfs dit beperk die pyn, en dit word 'n grap. Almal en niemand wil nie. Daar word nie gelag in die vallei nie. Dit is nodig om in die eiendom te belê, maar die lacinia moet gesê word. Soos die hartseer van die eros, maar die ultricies self, maar die voertuie van die diam van die sjokolade. \n\n Mauris het 'n urn nodig in haat van tincidunt ultricities a sed dui. Hy sorg vir homself maar wil in sy huiswerk belê. Soms word die gis opgesit. Elkeen word deur 'n massa geteiken. Dit is gerieflik vir swanger vroue. Môre, wat sal die probleem van pyn wees, het hy gesê. Daar word gesê dat hy in hierdie straat gewoon het. Môre en rou wys. Daar is geen kliniese belangstelling nie, of soms van tyd tot tyd. Daar is geen gif nie, en geen gifsneller nie. Elkeen van hulle was 'n ontwikkelaar, laag vir laag, en watter soort produk was dit. Kinderspeelgrond, sokker as 'n sokkerveld, voor dit swanger. Mauris ex tortor, saucement et eleifend et, euismod nie voor nie. Onverskrokke lorem nibh, die teiken en die teiken moet baie anders wees in die veld. \n\n Duis malesuada dui quis lorem sad aliquam Dit is 'n sagte slaai, maar ook nie 'n proteïenbed nie. Gelag in sokker. Totdat daar groot publisiteit is, behoort die huiswerk belangriker te wees as die basketbalsous. Donec massa massa, pharetra in ague a, imperdiet laoreet mauris. Vir die sous is die pyn nie op die punte gerig nie, net die lelike boog van die tincidunt, dit is belangrik vir die bevordering en opvoeding. Maar die hek, die ligula van die Euismod-hendrerit, was net 'n massa eiendom, en die samestelling van die lewe is nie aan die spelers geleen nie. Vir die kinders gaan ek terselfdertyd 'n slaai eet. Geen werknemer soos Lacinia, sokkerspeler, vlei die vryes nie. \n \n Môre hendrerit fermentum nibh sed faucibus Daar is niks maklik nie. Dis haat voorheen, maar die tyd is verby, altyd Euismod nou. In sed nisl 'n felis faucibus laoreet. Dit is nie nodig om rein te wees in enige hartseer oomblik of resultaat nie. Almal was die skrywer, maar die eiendom, pure hartseer. Elkeen van my leeus, of dit nou sag of gevarieerd is, sorg vir homself. Tot spotprent eiendomsontwikkelaars. Almal en Leo behoort gelukkig te wees tensy hulle baie besig is.",
  Spanish:
    "El cliente es muy importante, el cliente será seguido por el cliente. No debe haber coches, ni coches, ni camas sucias, ni platos sucios. Como empleado, no acepta el odio ni el deseo. fue un fin de semana Incluso si la venenosa Lacinia es genial, que sea mucho rhoncus arcu egestus ullamcorper. Cada vehículo no está a la venta. El precio del producto es diferente. Pero el triste detonante y la gran expectación, adornan la vida de la inmobiliaria. Sin producción y sin salsa. Vivamus halaga la risa del varón, necesita la vulputación antes de la inversión de la caricatura. Todo el mundo tiene que poner los jugadores. Hasta e incluso antes del teclado virtual. Incluso eso limita el dolor y se convierte en una broma. Todos y nadie quiere. No hay risa en el valle. Hay que invertir en los inmuebles, pero hay que decir la lacinia. Como el dolor del eros, pero los ultricios mismos, pero los vehículos del diam del chocolate. \n\n Mauris necesita una urna por odio a las tincidunt ultricies a sed dui. Se cuida pero quiere invertir en su tarea. A veces se pone la levadura. Cada uno es el objetivo de una masa. Es conveniente para las mujeres embarazadas. Mañana, cuál será el problema del dolor, dijo. Se dice que vivió en esta calle. Mañana y luto sabio. No hay interés clínico, oa veces de vez en cuando. No hay veneno, ni disparador de veneno. Cada uno de ellos era un revelador, capa por capa, y qué tipo de producto era. Parque infantil, fútbol como campo de fútbol, ​​embarazada antes de eso. Mauris ex tortor, saucement et eleifend et, euismod no antes. Intrépido lorem nibh, el objetivo y el objetivo deben ser mucho, diferentes en el campo. \n\n Duis malesuada dui quis lorem sad aliquam Es una ensalada blanda, pero tampoco es un lecho de proteínas. La risa en el fútbol. Hasta que haya una gran publicidad, la tarea debería ser más importante que la salsa del baloncesto. Donec massa massa, pharetra in ague a, imperdiet laoreet mauris. Para la salsa, el dolor no va dirigido a las puntas, solo el feo lazo del tincidunt, es importante para la promoción y educación. Pero la puerta, la ligula del Euismod hendrerit, no era más que una masa de propiedad, y la composición de la vida no se prestaba a los jugadores. Para los niños, voy a tener una ensalada al mismo tiempo. Ningún empleado como Lacinia, futbolista, halaga la libertad. \n \n Mañana hendrerit fermentum nibh sed faucibus No hay nada fácil. Es odio antes, pero el tiempo se acabó, siempre Euismod ahora. In sed nisl a felis faucibus laoreet. No hay necesidad de ser puro en ningún momento o resultado triste. Todo el mundo era autor, menos la inmobiliaria, pura pena. Cada uno de mis leones, ya sea suave o variado, se cuida solo. Hasta los desarrolladores de bienes raíces de dibujos animados. Todos y Leo deberían estar felices a menos que estén muy ocupados.",
};

// Promotions
export const promotions = [
  {
    "S/N": 0,
    Device: "Android",
    Country: "Nigeria",
    Title: "adsfgaskf",
    Images: [
      "https://picsum.photos/id/237/200/300",
      "https://picsum.photos/id/237/300/300",
      "https://picsum.photos/id/237/400/300",
      "https://picsum.photos/id/237/500/400",
    ],
  },
  {
    "S/N": 1,
    Device: "IOS",
    Country: "Nigeria",
    Title: "adsfgaskf",
    Images: [
      "https://picsum.photos/id/237/200/300",
      "https://picsum.photos/id/237/300/300",
      "https://picsum.photos/id/237/400/300",
      "https://picsum.photos/id/237/500/400",
    ],
  },
  {
    "S/N": 2,
    Device: "Android",
    Country: "Nigeria",
    Title: "adsfgaskf",
    Images: [
      "https://picsum.photos/id/237/200/300",
      "https://picsum.photos/id/237/300/300",
      "https://picsum.photos/id/237/400/300",
      "https://picsum.photos/id/237/500/400",
    ],
  },
  {
    "S/N": 3,
    Device: "Android",
    Country: "Benin",
    Title: "adsfgaskf",
    Images: [
      "https://picsum.photos/id/237/200/300",
      "https://picsum.photos/id/237/300/300",
      "https://picsum.photos/id/237/400/300",
      "https://picsum.photos/id/237/500/400",
    ],
  },
  {
    "S/N": 4,
    Device: "Android",
    Country: "Nigeria",
    Title: "adsfgaskf",
    Images: [
      "https://picsum.photos/id/237/200/300",
      "https://picsum.photos/id/237/300/300",
      "https://picsum.photos/id/237/400/300",
      "https://picsum.photos/id/237/500/400",
    ],
  },
  {
    "S/N": 5,
    Device: "Android",
    Country: "Benin",
    Title: "adsfgaskf",
    Images: [
      "https://picsum.photos/id/237/200/300",
      "https://picsum.photos/id/237/300/300",
      "https://picsum.photos/id/237/400/300",
      "https://picsum.photos/id/237/500/400",
    ],
  },
  {
    "S/N": 6,
    Device: "Android",
    Country: "Nigeria",
    Title: "adsfgaskf",
    Images: [
      "https://picsum.photos/id/237/200/300",
      "https://picsum.photos/id/237/300/300",
      "https://picsum.photos/id/237/400/300",
      "https://picsum.photos/id/237/500/400",
    ],
  },
  {
    "S/N": 7,
    Device: "IOS",
    Country: "Nigeria",
    Title: "adsfgaskf",
    Images: [
      "https://picsum.photos/id/237/200/300",
      "https://picsum.photos/id/237/300/300",
      "https://picsum.photos/id/237/400/300",
      "https://picsum.photos/id/237/500/400",
    ],
  },
  {
    "S/N": 8,
    Device: "IOS",
    Country: "Nigeria",
    Title: "adsfgaskf",
    Images: [
      "https://picsum.photos/id/237/200/300",
      "https://picsum.photos/id/237/300/300",
      "https://picsum.photos/id/237/400/300",
      "https://picsum.photos/id/237/500/400",
    ],
  },
  {
    "S/N": 9,
    Device: "IOS",
    Country: "Nigeria",
    Title: "adsfgaskf",
    Images: [
      "https://picsum.photos/id/237/200/300",
      "https://picsum.photos/id/237/300/300",
      "https://picsum.photos/id/237/400/300",
      "https://picsum.photos/id/237/500/400",
    ],
  },
  {
    "S/N": 10,
    Device: "IOS",
    Country: "Nigeria",
    Title: "adsfgaskf",
    Images: [
      "https://picsum.photos/id/237/200/300",
      "https://picsum.photos/id/237/300/300",
      "https://picsum.photos/id/237/400/300",
      "https://picsum.photos/id/237/500/400",
    ],
  },
  {
    "S/N": 11,
    Device: "IOS",
    Country: "Benin",
    Title: "adsfgaskf",
    Images: [
      "https://picsum.photos/id/237/200/300",
      "https://picsum.photos/id/237/300/300",
      "https://picsum.photos/id/237/400/300",
      "https://picsum.photos/id/237/500/400",
    ],
  },
  {
    "S/N": 12,
    Device: "IOS",
    Country: "Nigeria",
    Title: "adsfgaskf",
    Images: [
      "https://picsum.photos/id/237/200/300",
      "https://picsum.photos/id/237/300/300",
      "https://picsum.photos/id/237/400/300",
      "https://picsum.photos/id/237/500/400",
    ],
  },
  {
    "S/N": 13,
    Device: "IOS",
    Country: "Nigeria",
    Title: "adsfgaskf",
    Images: [
      "https://picsum.photos/id/237/200/300",
      "https://picsum.photos/id/237/300/300",
      "https://picsum.photos/id/237/400/300",
      "https://picsum.photos/id/237/500/400",
    ],
  },
  {
    "S/N": 14,
    Device: "IOS",
    Country: "Benin",
    Title: "adsfgaskf",
    Images: [
      "https://picsum.photos/id/237/200/300",
      "https://picsum.photos/id/237/300/300",
      "https://picsum.photos/id/237/400/300",
      "https://picsum.photos/id/237/500/400",
    ],
  },
];

// General Countries Page Data
export const generalCountriesPageData = [
  {
    "S/N": 0,
    "country name": "Nigeria",
    "country code": 234,
    "country flag": "🇳🇬",
    featured: "Yes",
  },
  {
    "S/N": 1,
    "country name": "Argentina",
    "country code": 54,
    "country flag": "🇦🇷",
    featured: "No",
  },
  {
    "S/N": 2,
    "country name": "Australia",
    "country code": 61,
    "country flag": "🇦🇺",
    featured: "Yes",
  },
  {
    "S/N": 3,
    "country name": "Aruba",
    "country code": 297,
    "country flag": "🇦🇼",
    featured: "No",
  },
  {
    "S/N": 4,
    "country name": "Bosnia and Herzegovina",
    "country code": 387,
    "country flag": "🇧🇦",
    featured: "No",
  },
  {
    "S/N": 5,
    "country name": "Bangladesh",
    "country code": 880,
    "country flag": "🇧🇩",
    featured: "Yes",
  },
  {
    "S/N": 6,
    "country name": "Bahrain",
    "country code": 973,
    "country flag": "🇧🇭",
    featured: "No",
  },
  {
    "S/N": 7,
    "country name": "Bermuda",
    "country code": 1,
    "country flag": "🇧🇲",
    featured: "Yes",
  },
  {
    "S/N": 8,
    "country name": "Benin",
    "country code": 229,
    "country flag": "🇧🇯",
    featured: "No",
  },
  {
    "S/N": 9,
    "country name": "Bolivia, Plurinational...",
    "country code": 591,
    "country flag": "🇧🇴",
    featured: "Yes",
  },
  {
    "S/N": 10,
    "country name": "Brazil",
    "country code": 55,
    "country flag": "🇧🇷",
    featured: "No",
  },
  {
    "S/N": 11,
    "country name": "Bahamas",
    "country code": 1,
    "country flag": "🇧🇸",
    featured: "Yes",
  },
];

// Parish Countries Page Data
export const parishCountriesPageData = [
  {
    "S/N": 0,
    "country name": "Nigeria",
    category: "West Africa 1",
  },
  {
    "S/N": 1,
    "country name": "Argentina",
    category: "West Africa 1",
  },
  {
    "S/N": 2,
    "country name": "Australia",
    category: "West Africa 1",
  },
  {
    "S/N": 3,
    "country name": "Aruba",
    category: "West Africa 1",
  },
  {
    "S/N": 4,
    "country name": "Bosnia and Herzegovina",
    category: "West Africa 1",
  },
  {
    "S/N": 5,
    "country name": "Bangladesh",
    category: "West Africa 1",
  },
  {
    "S/N": 6,
    "country name": "Bahrain",
    category: "West Africa 2",
  },
  // {
  //   "S/N": 7,
  //   "country name": "Bermuda",
  //   category: "West Africa 2",
  // },
  // {
  //   "S/N": 8,
  //   "country name": "Benin",
  //   category: "West Africa 2",
  // },
  {
    "S/N": 9,
    "country name": "Bolivia, Plurinational...",
    category: "Central Africa",
  },
  {
    "S/N": 10,
    "country name": "Brazil",
    category: "Central Africa",
  },
  {
    "S/N": 11,
    "country name": "Bahamas",
    category: "Central Africa",
  },
];

// General Countries
export const generalCountries = [
  { title: "Nigeria", flag: "🇳🇬" },
  { title: "Argentina", flag: "🇦🇷" },
  { title: "Australia", flag: "🇦🇺	" },
  { title: "Aruba", flag: "🇦🇼" },
  { title: "Bosnia and Herzegovina", flag: "🇧🇦" },
  { title: "Bangladesh", flag: "🇧🇩" },
  { title: "Bahrain", flag: "🇧🇭" },
  { title: "Bermuda", flag: "🇧🇲" },
  { title: "Benin", flag: "🇧🇯" },
  { title: "Bolivia, Plurinational...", flag: "🇧🇴" },
  { title: "Brazil", flag: "🇧🇷" },
  { title: "Bahamas", flag: "🇧🇸" },
];

// Parish Countries
export const parishCountries = [
  { title: "Nigeria", flag: NigerianFlag },
  { title: "Argentina", flag: ArgentinaFlag },
  { title: "Australia", flag: AustraliaFlag },
  { title: "Aruba", flag: ArubaFlag },
  { title: "Bosnia and Herzegovina", flag: BosniaAndHerzegovinaFlag },
  { title: "Bangladesh", flag: BangladeshFlag },
  { title: "Bahrain", flag: BahrainFlag },
  // { title: "Bermuda", flag: BermudaFlag },
  // { title: "Benin", flag: BeninFlag },
  { title: "Bolivia, Plurinational...", flag: BoliviaFlag },
  { title: "Brazil", flag: BrazilFlag },
  { title: "Bahamas", flag: BahamasFlag },
];

// Parish Country Categories
export const parishCountryCategories = [
  { category: "West Africa 1" },
  { category: "West Africa 2" },
  { category: "West Africa 3" },
  { category: "Central Africa" },
  { category: "Other Countries" },
];

// Languages
export const languages = [
  "English",
  "Español",
  "Fula",
  "Français",
  "Hausa",
  "Português",
  "Pidgin",
];

// Admins
export const admins = [
  {
    "S/N": 0,
    Name: "Neil Sims",
    "Email 1": "example@gmail.com",
    "Email 2": "example@gmail.com",
    "Email 3": "example@gmail.com",
  },
  {
    "S/N": 1,
    Name: "Neil Sims",
    "Email 1": "example@gmail.com",
    "Email 2": "example@gmail.com",
    "Email 3": "example@gmail.com",
  },
  {
    "S/N": 2,
    Name: "Jack Sims",
    "Email 1": "example@gmail.com",
    "Email 2": "example@gmail.com",
    "Email 3": "example@gmail.com",
  },
  {
    "S/N": 3,
    Name: "Neil Sims",
    "Email 1": "example@gmail.com",
    "Email 2": "example@gmail.com",
    "Email 3": "example@gmail.com",
  },
  {
    "S/N": 4,
    Name: "Neil Sims",
    "Email 1": "example@gmail.com",
    "Email 2": "example@gmail.com",
    "Email 3": "example@gmail.com",
  },
];

// Provinces
export const provinces = [
  { "S/N": 0, code: "AK", province: "Alaska", region: "Southie" },
  { "S/N": 1, code: "AL", province: "Alabama", region: "Southie" },
  { "S/N": 2, code: "AR", province: "Arkansas", region: "Southie" },
  { "S/N": 3, code: "AS", province: "American Samoa", region: "Southie" },
  { "S/N": 4, code: "AZ", province: "Arizona", region: "Southie" },
  { "S/N": 5, code: "CA", province: "California", region: "Southie" },
  { "S/N": 6, code: "CO", province: "Colorado", region: "Southie" },
  { "S/N": 7, code: "CT", province: "Connecticut", region: "Southie" },
  { "S/N": 8, code: "DC", province: "District of Columbia", region: "Southie" },
  { "S/N": 9, code: "DE", province: "Delaware", region: "Southie" },
  { "S/N": 10, code: "FL", province: "Florida", region: "Southie" },
  { "S/N": 11, code: "GA", province: "Georgia", region: "Southie" },
  { "S/N": 12, code: "GU", province: "Guam", region: "Southie" },
  { "S/N": 13, code: "HI", province: "Hawaii", region: "Southie" },
  { "S/N": 14, code: "IA", province: "Iowa", region: "Southie" },
  { "S/N": 15, code: "ID", province: "Idaho", region: "Southie" },
  { "S/N": 16, code: "IL", province: "Illinois", region: "Southie" },
  { "S/N": 17, code: "IN", province: "Indiana", region: "Southie" },
  { "S/N": 18, code: "KS", province: "Kansas", region: "Southie" },
  { "S/N": 19, code: "KY", province: "Kentucky", region: "Southie" },
  { "S/N": 20, code: "LA", province: "Louisiana", region: "Southie" },
  { "S/N": 21, code: "MA", province: "Massachusetts", region: "Southie" },
  { "S/N": 22, code: "MD", province: "Maryland", region: "Southie" },
  { "S/N": 23, code: "ME", province: "Maine", region: "Southie" },
  { "S/N": 24, code: "MI", province: "Michigan", region: "Southie" },
  { "S/N": 25, code: "MN", province: "Minnesota", region: "Southie" },
  { "S/N": 26, code: "MO", province: "Missouri", region: "Southie" },
  { "S/N": 27, code: "MS", province: "Mississippi", region: "Southie" },
  { "S/N": 28, code: "MT", province: "Montana", region: "Southie" },
  { "S/N": 29, code: "NC", province: "North Carolina", region: "Southie" },
  { "S/N": 30, code: "ND", province: "North Dakota", region: "Southie" },
  { "S/N": 31, code: "NE", province: "Nebraska", region: "Southie" },
  { "S/N": 32, code: "NH", province: "New Hampshire", region: "Southie" },
  { "S/N": 33, code: "NJ", province: "New Jersey", region: "Southie" },
  { "S/N": 34, code: "NM", province: "New Mexico", region: "Southie" },
  { "S/N": 35, code: "NV", province: "Nevada", region: "Southie" },
  { "S/N": 36, code: "NY", province: "New York", region: "Southie" },
  { "S/N": 37, code: "OH", province: "Ohio", region: "Southie" },
  { "S/N": 38, code: "OK", province: "Oklahoma", region: "Southie" },
  { "S/N": 39, code: "OR", province: "Oregon", region: "Southie" },
  { "S/N": 40, code: "PA", province: "Pennsylvania", region: "Southie" },
  { "S/N": 41, code: "PR", province: "Puerto Rico", region: "Southie" },
  { "S/N": 42, code: "RI", province: "Rhode Island", region: "Southie" },
  { "S/N": 43, code: "SC", province: "South Carolina", region: "Southie" },
  { "S/N": 44, code: "SD", province: "South Dakota", region: "Southie" },
  { "S/N": 45, code: "TN", province: "Tennessee", region: "Southie" },
  { "S/N": 46, code: "TX", province: "Texas", region: "Southie" },
  { "S/N": 47, code: "UT", province: "Utah", region: "Southie" },
  { "S/N": 48, code: "VA", province: "Virginia", region: "Southie" },
  { "S/N": 49, code: "VI", province: "Virgin Islands", region: "Southie" },
  { "S/N": 50, code: "VT", province: "Vermont", region: "Southie" },
  { "S/N": 51, code: "WA", province: "Washington", region: "Southie" },
  { "S/N": 52, code: "WI", province: "Wisconsin", region: "Southie" },
  { "S/N": 53, code: "WV", province: "West Virginia", region: "Southie" },
  { "S/N": 54, code: "WY", province: "Wyomin", region: "Southie" },
];

// Regions
export const regions = [
  { "S/N": 0, region: "Northeast", country: "USA" },
  { "S/N": 1, region: "Southwest", country: "USA" },
  { "S/N": 2, region: "West", country: "USA" },
  { "S/N": 3, region: "Southeast", country: "USA" },
  { "S/N": 4, region: "Midwes", country: "USA" },
];

// Categories
export const bookCategories = ["Story", "Manual", "Article", "Activity"];

// Languages
export const bookLanguages = [
  "English",
  "Español",
  "Fula",
  "Français",
  "Hausa",
  "Igbo",
  "Português",
  "Pidgin",
  "Yoruba",
];

export const themes = {
  error: "border-red-600 bg-red-100 text-red-600",
  info: "border-blue-600 bg-blue-100 text-blue-600",
  warning: "border-yellow-600 bg-yellow-100 text-yellow-600",
  success: "border-green-600 bg-green-100 text-green-600",
};

export const paginationEntries = ["All", 50, 100, 200, 500, 1000];
